//__TODO__: restructure error messages by module,
//__TODO__: move non message keys into constants
const MESSAGES = {
  SEND_TO_REVIEW_SUCCESS: "Sent for review",
  SEND_TO_REVIEW_FAILED: "Send for review failed",
  SEND_TO_REVIEW_PROGRESS: "Sending for review",

  FORM_MAPPING_SUCCESS: "Field mappings saved",
  FORM_MAPPING_FAILED: "Failed to save field mappings",
  FORM_MAPPING_PROGRESS: "Saving field mappings",

  SURVEY_SELECT_MESSAGE: "Please select survey type and category.",

  SAVING_REMOTE_SURVEY: "Saving Remote Survey",
  REMOTE_SURVEY_SAVED: "Remote Survey Saved",
  FAILD_TO_SAVE_REMOTE_SURVEY: "Failed to save Remote Survey",
  REMOTE_SURVEY_UPDATED: "Remote Survey request updated",

  FORM_DATA_SUCCESS: "Form saved",
  FORM_DATA_COMPLETED: "Form Completed",
  FORM_DATA_ACCEPTED: "Form Accepted",
  FORM_DATA_UPDATED: "Form Updated",
  FORM_DATA_PROGRESS: "Saving Form",
  FORM_DATA_FAILED: "Failed to save form",
  COMPANY_NOT_APPROVE: "Please Approve company registration request",
  ACCEPT_FORM_DATA_PROGRESS: "Accepting Form",
  UPDATE_FORM_DATA_PROGRESS: "Updating Form",
  ACCEPT_FORM_DATA_FAILED: "Failed to Accept form",
  UPDATE_FORM_DATA_FAILED: "Failed to Update form",

  SYNC_OFFLINE_FAILED: "Sync to offline application failed",
  SYNC_OFFLINE_SUCCESS: "Data is now ready in desktop application for offline survey.",

  NO_FORMS: "No forms found",
  NO_FORM: "No form found",
  NO_SURVEY: "No reports found",
  NO_SUPPORTING_DOCUMENTS: "No supporting documents found",
  NO_NC_DOCUMENTS: "Atleast one document upload required",

  ADD_VISIT_PLANNING_FAILED: "Failed to save visit planning",

  REPORT_NO_GENERATED: "Report number has been generated",
  REPORT_NO_GENERATING: "Report number is being generated",
  REPORT_NO_GENERATE_FAILED: "Failed to generate report number",

  ACTUAL_AUDIT_PLACE_UPDATE: "Place of Actual Audit has been updated",
  ACTUAL_AUDIT_PLACE_UPDATING: "Place of Actual Audit is being updated",
  ACTUAL_AUDIT_PLACE_UPDATE_FAILED: "Failed to update Place of Actual Audit",

  ACTUAL_SURVEY_PLACE_UPDATE: "Place of Actual Survey has been updated",
  ACTUAL_SURVEY_PLACE_UPDATING: "Place of Actual Survey is being updated",
  ACTUAL_SURVEY_PLACE_UPDATE_FAILED: "Failed to update Place of Actual Survey",

  SEND_TO_DGS_PROGRESS: "Sending to DGS",
  SEND_SUCCESS: "Sent",
  SEND_DGS_SUCCESS: "Documents Dispatched to DGS",
  SEND_DGS_FAILED: "Sending to DGS failed",

  SEND_AUTH_PROGRESS: "Sending authorisation letter",
  SEND_AUTH_FAILED: "Sending authorisation letter failed",
  SEND_AUTH_SUCCESS: "Authorisation letter sent",

  COMPLETE_AUTH_PROGRESS: "Completing authorisation letter",
  COMPLETE_AUTH_FAILED: "Failed to complete authorisation letter",
  COMPLETE_AUTH_SUCCESS: "Authorisation letter completed",

  APPROVE_AUTH_PROGRESS: "Approving authorisation letter",
  APPROVE_AUTH_FAILED: "Failed to approve authorisation letter",
  APPROVE_AUTH_SUCCESS: "Authorisation letter Approved",

  SEND_PROV_AUTH_PROGRESS: "Sending provisional authorisation letter",
  SEND_PROV_AUTH_FAILED: "Sending provisional authorisation letter failed",
  SEND_PROV_AUTH_SUCCESS: "Provisional Authorisation letter sent",

  COMPLETE_PROV_AUTH_PROGRESS: "Completing provisional authorisation letter",
  COMPLETE_PROV_AUTH_FAILED: "Failed to complete provisional authorisation letter",
  COMPLETE_PROV_AUTH_SUCCESS: "Provisional Authorisation letter completed",

  APPROVE_PROV_AUTH_PROGRESS: "Approving provisional authorisation letter",
  APPROVE_PROV_AUTH_FAILED: "Failed to approve provisional authorisation letter",
  APPROVE_PROV_AUTH_SUCCESS: "Provisional Authorisation letter Approved",

  SUBMIT_AUTH_PROGRESS: "Sending Request for Auth Letter Preparation",
  SUBMIT_AUTH_FAILED: "Request failed for Auth Letter Preparation",
  SUBMIT_AUTH_SUCCESS: "Request sent for Auth Letter Preparation",

  AUTHORISED_AUTH_PROGRESS: "Authorising Authorisation Letter",
  AUTHORISED_AUTH_FAILED: "Authorising authorisation letter failed",
  AUTHORISED_AUTH_SUCCESS: "Authorisation letter Authorised",

  SURVEY_AUTHORISED_AUTH_PROGRESS: "Authorising survey request",
  SURVEY_AUTHORISED_AUTH_FAILED: "Authorising survey request failed",
  SURVEY_AUTHORISED_AUTH_SUCCESS: "Survey request Authorised",

  SAVE_AUTH_LETTER_PROGRESS: "Saving authorisation letter",
  SAVE_AUTH_LETTER_SUCCESS: "Authorisation letter saved",
  SAVE_AUTH_LETTER_FAILED: "Failed to save authorisation letter",

  SAVE_SHIP_DETAILS: "Saving ship details",
  SAVE_SHIP_DETAILS_SUCCESS: "Ship Details saved",
  SAVE_SHIP_DETAILS_FAILED: "Failed to save ship details",

  UPDATE_SHIP_DETAILS: "Updating ship details",
  UPDATE_SHIP_DETAILS_SUCCESS: "Ship Details updated",
  UPDATE_SHIP_DETAILS_FAILED: "Failed to update ship details",

  SAVE_OWNER_LETTER_PROGRESS: "Saving owner letter",
  SAVE_OWNER_LETTER_SUCCESS: "Owner letter saved",
  SAVE_OWNER_LETTER_FAILED: "Failed to save owner letter",

  SEND_OWNER_PROGRESS: "Sending owner letter",
  SEND_OWNER_FAILED: "Sending owner letter failed",
  SEND_OWNER_SUCCESS: "Owner letter sent",

  SAVE_PROVISIONAL_AUTH_LETTER_PROGRESS: "Saving provisional authorisation letter",
  SAVE_PROVISIONAL_AUTH_LETTER_SUCCESS: "Provisional Authorisation letter saved",
  SAVE_PROVISIONAL_AUTH_LETTER_FAILED: "Failed to save provisional authorisation letter",

  SUBMIT_FOR_AUTHORISATION: "Submitting for authorisation",
  SUBMITED_FOR_AUTHORISATION: "Submitted for authorisation",
  SUBMITED_FOR_AUTHORISATION_FAILED: "Failed to Submitted for authorisation",

  UPDATE_UPLOAD_EMAIL_PROGRESS: "Updating uploaded email",
  UPDATE_UPLOAD_EMAIL_SUCCESS: "Upload email updated",
  UPDATE_UPLOAD_EMAIL_FAILED: "Failed to update upload email",

  SAVE_UPLOAD_EMAIL_PROGRESS: "Saving upload email",
  SAVE_UPLOAD_EMAIL_SUCCESS: "Upload email saved",
  SAVE_UPLOAD_EMAIL_FAILED: "Failed to save upload email",

  UPDATE_PREPARE_AGREEMENT_PROGRESS: "Updating Agreement",
  UPDATE_PREPARE_AGREEMENT_SUCCESS: "Agreement Updated",
  UPDATE_PREPARE_AGREEMENT_FAILED: "Failed to update Agreement",

  SAVE_PREPARE_AGREEMENT_PROGRESS: "Saving Agreement",
  SAVE_PREPARE_AGREEMENT_SUCCESS: "Agreement saved",
  SAVE_PREPARE_AGREEMENT_FAILED: "Failed to save Agreement",

  SEND_DOC_REQ_PROGRESS: "Sending Document Request.",
  SEND_DOC_REQ_SUCCESS: "Document Request Sent",
  SEND_DOC_REQ_FAILED: "Document Request Failed",

  SIGN_IN_PROGRESS: "Signing in",
  SIGN_IN_WRONG_DATA: "	The username or password you entered is incorrect",
  SIGN_IN_FAILED: "Bad Request. Please try again later.",
  REGISTER_PROGRESS: "Registering",
  REGISTER_SUCCESS: "Registered",
  REGISTER_FAILED: "Failed to Register. Please try again later.",

  RETURN_PROGRESS: "Returning for amendment",
  RETURN_SUCCESS: "Returned for amendment",
  RETURN_ERROR: "Returning for amendment failed",

  ESP_RETURN_PROGRESS: "Returning for correction",
  ESP_RETURN_SUCCESS: "Returned for correction",
  ESP_RETURN_ERROR: "Returning for correction failed",

  ESP_PASS_FOR_REVIEW_PROGRESS: "Passing for review",
  ESP_PASS_FOR_REVIEW_SUCCESS: "Passed for review",
  ESP_PASS_FOR_REVIEW_ERROR: "Passing for review failed",

  ESP_SAVE_REVIEW_PROGRESS: "Saving for review",
  ESP_SAVE_REVIEW_SUCCESS: "Saved for review",
  ESP_SAVE_REVIEW_ERROR: "Saving for review failed",

  DELETE_PROGRESS: "Deleting internal auditors",
  DELETE_SUCCESS: "Internal auditor deleted",
  DELETE_ERROR: "Failed to delete internal auditor",

  SAVE_VISIT_PROGRESS: "Saving visit details",
  SAVE_VISIT_SUCCESS: "Visit details saved",
  SAVE_VISIT_ERROR: "Failed to save visit details",

  UPDATE_EVENT_PROGRESS: "Updating event",
  UPDATE_EVENT_SUCCESS: "Event updated",
  UPDATE_EVENT_ERROR: "Failed to update",

  ADD_EVENT_PROGRESS: "Adding event",
  ADD_EVENT_SUCCESS: "Event added",
  ADD_EVENT_ERROR: "Failed to add event",

  SAVE_EVENT_PROGRESS: "Saving event",
  SAVE_EVENT_SUCCESS: "Event saved",
  SAVE_EVENT_ERROR: "Failed to save event",

  REMOVE_EVENT_PROGRESS: "Removing event",
  REMOVE_EVENT_SUCCESS: "Event removed",
  REMOVE_EVENT_ERROR: "Failed to remove event",

  SAVE_AUDITS_PROGRESS: "Saving audit details",
  SAVE_AUDITS_SUCCESS: "Audit details saved",
  SAVE_AUDITS_ERROR: "Saving audit details failed",
  SAVE: "Save",

  UPDATE_AUDITS_SUCCESS: "Audit details updated",
  UPDATE_SURVEY_PROGRESS: "Updating survey status report",
  UPDATE_SURVEY_SUCCESS: "Survey status report updated",
  UPDATE_SURVEY_ERROR: "Failed to update survey status report",
  NOTIFY_TEAM_PROGRESS: "Notifying team",
  NOTIFY_TEAM_SUCCESS: "Team is notified",
  NOTIFY_TEAM_ERROR: "Failed to notify team",

  NC_SUBMITION_PROGRESS: "Submitting NC closure request report",
  NC_SUBMITED_SUCCESS: "NC closure request report submitted",
  NC_SUBMITION_ERROR: "Failed to submit NC closure request report",

  DOWNLOAD_PROGRESS: "Downloading",
  DOWNLOAD_SUCCESS: "Downloaded successfully",
  DOWNLOAD_FAILED: "Failed to download",

  PREVIEW_SUCCESS: "Preview success",
  PREVIEW_PROGRESS: "Generating preview",
  PREVIEW_FAILED: "Failed to preview",

  WITHDRAWN_CERTIFICATE_SUCCESS: "Certificate Withdrawn Successfully",
  WITHDRAWN_CERTIFICATE_PROGRESS: "Withdrawing Certificate in Progress",
  WITHDRAWN_CERTIFICATE_FAILED: "Certificate Withdrawal Failed",
  CONFIRM_WITHDRAW_CERTIFICATE: "This action will withdraw the certificate. Do you want to proceed?",

  PLEASE_SELECT_AUDITOR: "Please select auditor",

  ASSIGNED_AUDITOR_SUCCESS: "Auditor assigned",
  ASSIGNED_AUDITOR_PROGRESS: "Assigning auditor",
  ASSIGN_AUDITOR_FAILED: "Failed to assign auditor",

  ASSIGNED_SURVEYOR_SUCCESS: "Surveyor assigned",
  ASSIGNED_SURVEYOR_PROGRESS: "Assigning surveyor",
  ASSIGN_SURVEYOR_FAILED: "Failed to assign Surveyor",

  REPORT_NUMBER_NOT_GENERATED: "Report number",

  NO_RECORDS_FOUND_FOR_SEARCH: "No data found. Please try changing the search criteria.",

  NO_RECORDS_FOUND: "No records found.",
  NO_RECORDS_FOUND_FOR_FORM_BUILDER: "No forms found.",
  NO_CERTIFICATES_FOUND: "No Certificates found.",

  SAVING_CONTRACT_REVIEW_PROGRESS: "Saving Contract Review",
  SAVING_CONTRACT_REVIEW_SUCCESS: "Contract Review saved",
  SAVING_SURVEY_REQUEST_FAILED: "Failed to save Survey Request",
  SAVING_CONTRACT_REVIEW_FAILED: "Failed to save Contract Review",
  SAVING_CONTRACT_REVIEW_FAILED_CHECK_DEFECIENCIES: "No FSI/PSC Detention deficiencies found",
  SSA_DUPLICATE_REQUEST: "A request already exists for the same scope. Please check and try again.",
  SAVING_SURVEY_REQUEST_PROGRESS: "Saving Survey Request",

  AMEND_CONTRACT_REVIEW_PROGRESS: "Amending Contract Review",
  AMEND_CONTRACT_REVIEW_SUCCESS: "Contract Review amended",
  AMEND_CONTRACT_REVIEW_FAILED: "Failed to amend Contract Review",

  AMEND_SURVEY_REQUEST_PROGRESS: "Amending survey request",
  AMEND_SURVEY_REQUEST_SUCCESS: "Survey request amended",
  AMEND_SURVEY_REQUEST_FAILED: "Failed to amend survey request",

  AMEND_CUSTOMER_REQUEST_PROGRESS: "Amending Customer request",
  AMEND_CUSTOMER_REQUEST_SUCCESS: "Customer request amended",
  AMEND_CUSTOMER_REQUEST_FAILED: "Failed to amend Customer request",

  REASSIGN_SS_PROGRESS: "Reassigning Survey Station",
  REASSIGN_SS_SUCCESS: "Survey Station Reassigned",
  REASSIGN_SS_FAILED: "Failed to reassign Survey Station",

  INITIALTE_DOCUMENT_REVIEW_INPROGRESS: "Initiating document review",
  INITIALTE_DOCUMENT_REVIEW_SUCCESS: "Document review initiated",

  UPDATE_CONTRACT_REVIEW_PROGRESS: "Updating Contract Review",

  UPLOAD_DOC_PROGRESS: "Uploading document",
  UPLOAD_DOC_SUCCESS: "Document uploaded",
  UPLOAD_DOC_FAILED: "Document uploading failed",
  UPLOAD_ALL_DOC:
    "Please upload at least one document for each required item in the document list, excluding 'Approval by Flags and Other IACS class Certificates' and 'Any other documents' .",
  UPLOAD_DOC_FILE_SIZE_ERROR: "Please upload file less than 12 MB",
  UPLOAD_DOC_FILE_TYPE_ERROR: "Please upload only pdf files",
  UPLOAD_DOC_HO_FILE_SIZE_ERROR: "Please upload file less than 30 MB",
  UPLOAD_SRFA_DOC_FILE_SIZE_ERROR: "Please upload a file smaller than 30 MB or use a compressed ZIP file", 
  NO_FILES_TO_UPLOAD: "File is not selected to upload",
  UPLOAD_ONE_FILE: "Please upload a file",
  UPLOAD_ONE_MANDATORY_FILES: "Please upload a mandatory files",
  UPLOAD_IMG_FILE_TYPE_ERROR: "Please upload only JPG/PNG/JPEG files",
  UPLOAD_PDF_FILE_TYPE_ERROR: "Please upload only PDF files",

  DELETE_DOC_CONFIRMATION: "The document will be deleted and cannot be retrieved",
  DELETE_DOC_PROGRESS: "Deleting document",
  DELETE_DOC_SUCCESS: "Document deleted",
  DELETE_DOC_FAILED: "Failed to delete document",
  DELETE_DOC_WARNING_AUTH_PERSON: "You are not authorised to delete document",
  FINAL_AGREEMENT_CONFIRMATION: "Once the final agreement is sent, you won’t be able to send it again",
  FINAL_AGREEMENT_PROGRESS: "Sending final agreement",
  FINAL_AGREEMENT_SUCCESS: "Final Emergency Response Service Agreement has been sent via email",
  FINAL_AGREEMENT_FAILED: "Failed to send the final agreement",

  SAVE_DOC_PROGRESS: "Adding document",
  SAVE_DOC_SUCCESS: "Document added",
  SAVE_DOC_FAILED: "Failed to save document",

  CONFIRM_APPROVE: "Do you want to approve this report?",
  APPROVE_PROGRESS: "Approving",
  REVIEW_PROGRESS: "Reviewing",
  REVIEW_SUCCESS: "Reviewed",
  REVIEW_FAILED: "Failed to review",
  APPROVE_SUCCESS: "Authorised",
  APPROVE_FAILED: "Failed to approve",
  REPORTS_AUTHORIZED_SUCCESS: "Reports Authorized",

  CONFIRM_UNAUTHORISED_SURVEY: "Do you want to unauthorise reports?",
  UNAUTHORISED_PROGRESS: "Unauthorising survey reports",
  UNAUTHORISED_SUCCESS: "Unauthorised survey reports",
  UNAUTHORISED_FAILED: "Failed to Unauthorise survey reports",

  CONFIRM_AUTHORIZE_CERT: "Do you want to authorise this certificates?",
  CONFIRM_AUTHORIZE: "Do you want to authorise this report?",
  AUTHORIZE_PROGRESS: "Authorising",
  AUTHORIZE_SUCCESS: "Survey has been completed",
  FEEDBACK_COMPLETE: "Feedback review has been completed",
  AUTHORIZE_ERROR: "Failed to authorise",
  CONFIRM_COMPLETE: "Do you want to complete this audit?",
  REPORT_SEND_TO_MR_INPROGRESS: "Report is sending to mr",
  REPORT_SEND_TO_MR: "Report sent to MR for review",
  REPORT_SEND_TO_MR_FAILED: "Report sent to MR for review failed",

  REPORT_PICK_CONFIRMATION: "Do you want to pick up report for review?",
  REPORT_PICKING_UP_REVIEW: "Report picking up for review",
  REPORT_PICKED_UP_REVIEW_SUCCESS: "Report picked for review",
  REPORT_PICKED_UP_FAIL: "Failed in picking up report",

  ON_HOLD_REPORT_PICK_CONFIRMATION: "Do you want to hold review of report?",
  ON_HOLD_REPORT_PICKING_UP_REVIEW: "Placing review of report on hold",
  ON_HOLD_REPORT_PICKED_UP_REVIEW_SUCCESS: "Review of report On hold",
  ON_HOLD_REPORT_PICKED_UP_FAIL: "Failed to place review of report on hold",

  BSA_REACTIVE_COMPANY_CONFIRMATION: "Do you want to deactivate company?",
  BSA_ACTIVE_COMPANY_CONFIRMATION: "Do you want to activate company?",
  BSA_REJECT_COMPANY_CONFIRMATION: "Do you want to reject this company?",
  BSA_REJECTED_COMPANY_CONFIRMATION: "Company is rejected",
  BSA_COMPANY_STATUS_PROGRESS: "Updating company details",
  BSA_COMPANY_REJECT_PROGRESS: "Rejecting company details",
  BSA_COMPANY_ACTIVATED: "Company activated",
  BSA_COMPANY_REACTIVATED: "Company deactivated",
  BSA_COMPANY_ACTIVATION_FAILED: "Failed to update company status",

  DEACTIVATE_CERTIFICATE: "Certificate deactivated",
  DEACTIVATE_CERTIFICATE_FAILED: "Failed to deactivate certificate",
  DEACTIVATE_CERTIFICATE_INPROGRESS: "Deactivating Certificate",

  SRF_AMENDMEND_CONFIRMATION: "Do you want to amend the SRF?",

  REPORT_DISMISS_CONFIRMATION: "Do you want to dismiss report from review?",
  REPORT_DISMISSING_REVIEW: "Report Dismissing from review",
  REPORT_DISMISSED_SUCCESS: "Report Dissmissed from review",
  REPORT_DISMISSED_FAILED: "Failed to Dismissed",

  UPDATE_REMARK_PROGRESS: "Updating remark",
  UPDATE_REMARK_SUCCESS: "Remark updated",
  UPDATE_REMARK_ERROR: "Failed to update remark",

  REMARK_PROGRESS: "Adding remark",
  REMARK_SUCCESS: "Remark added",
  REMARK_ERROR: "Failed to add remark",

  SAVING_SCOPE_DETAILS_PROGRESS: "Saving scope details",
  SAVING_SCOPE_DETAILS_SUCCESS: "Scope details saved.",
  SAVING_SCOPE_DETAILS_ERROR: "Failed to save scope details.",

  REMOVE_REMARK_PROGRESS: "Removing remark",
  REMOVE_REMARK_SUCCESS: "Remark removed",
  REMOVE_REMARK_ERROR: "Failed to remove remark",

  FORM_DATA_SUBMIT_SUCCESS: "Data saved",
  FORM_DATA_SUBMIT_PROGRESS: "Saving form data",
  FORM_DATA_EMAIL_SENT_SUCCESS: "Mail sent successfully",
  AUTHORISATION_SUBMIT_SUCCESS: "Authorization letter saved",

  NEW_COMPANY_DETAIL_SAVED: "New company details saved",
  NEW_COMPANY_DETAIL_PROGRESS: "Saving company details",
  FAILED_TO_SAVE_NEW_COMPANY_DETAILS: "Failed to save new company details",
  FAILED_TO_ACTIVE_NEW_CLIENT_DETAILS: "Failed to active new client details",
  ACTIVE_NEW_CLIENT_DETAILS: "Active Client Details",

  FAILED_TO_SAVE_NEW_COMPANY_DETAILS_CONFLICT: "Company with the same LRF number already exists. Please check",
  SAVING_NEW_COMPANY_DETAIL: "Saving new company details",
  USERNAME_EMAIL_ERROR_MESSAGE: "Name, Email or Username should be unique",

  EDITED_COMPANY_DETAIL: "Company details edited",
  FAILED_TO_EDIT_COMPANY_DETAILS: "Failed to edit company details",
  EDITING_COMPANY_DETAIL: "Editing company details",

  SENDING_EMAIL: "Sending Email",
  EMAIL_SEND_SUCCESS: "Email sended",
  FAILED_TO_SEND_EMAIL: "Failed to send email",
  EMAIL_SENT_SUCCESS: "Sent Email",

  NEW_BRANCH_DETAIL_SAVED: "New Branch saved",
  FAILED_TO_SAVE_NEW_BRANCH: "Failed to save new branch",
  SAVING_NEW_BRANCH: "Saving new branch",

  HIGH_RISK_VESSELS_SAVED: "High Risk Vessel Saved",
  FAILED_SAVE_TO_HIGH_RISK_VESSELS: "Failed to save High Risk Vessel",
  SAVING_HIGH_RISK_VESSELS: "Saving High Risk Vessels",

  HIGH_RISK_VESSELS_UPDATED: "High Risk Vessel Updated",
  FAILED_TO_UPDATE_HIGH_RISK_VESSELS: "Failed to update High Risk Vessel",
  UPDATING_HIGH_RISK_VESSELS: "Updating High Risk Vessels",

  POSTPONEMENT_EXT_MON_SAVED: "Postponement ext monitoring Saved",
  FAILED_SAVE_TO_POSTPONEMENT_EXT_MON: "Failed to save Postponement ext monitoring",
  SAVING_POSTPONEMENT_EXT_MON: "Saving Postponement ext monitorings",

  POSTPONEMENT_EXT_MON_UPDATED: "Postponement ext monitoring Updated",
  FAILED_TO_UPDATE_POSTPONEMENT_EXT_MON: "Failed to update Postponement ext monitoring",
  UPDATING_POSTPONEMENT_EXT_MON: "Updating Postponement ext monitoring",

  DELETING_SUB_FORM_PROGRESS: "Deleting form",
  SUB_FORM_DELETE_FAILED: "Failed to delete form",

  DELETING_MSQS_FORM_PROGRESS: "Deleting MS/QS Record.",
  DELETING_MSQS_FORM_SUCCESS: "MS/QS Record Deleted",
  DELETING_MSQS_FORM_FAILED: "Failed to delete MS/QS Record",

  FORM_DATA_SUBMIT_FAILED: "Failed to save form data",
  REQUEST_EXIST: "Request is already in pending state",

  DELETE_EVENT_PROGRESS: "Deleting event",
  DELETE_EVENT_SUCCESS: "Event deleted",
  DELETE_EVENT_ERROR: "Failed to delete event",

  THIS_FIELD_IS_REQUIRED: "This field is required",

  FORM_SUCCESSFULLY_RESET: "Successfully reset",

  SURVEY_VISIT_LIMIT_WARNING: "You enter more minutes then actual",

  ARE_YOU_SURE: "Are you sure?",
  ARE_YOU_SURE_FOR_CREATE_REQUEST: "Are you sure you want to create request?",
  ARE_YOU_SURE_TO_DELETE_THIS_ROW: "Are you sure you want to delete this row?",

  ARE_YOU_SURE_YOU_WANT_TO_SEND_SUPPLEMENTS_AND_CERTIFICATES_FOR_REVIEW: "Are you sure you want to send certificates and supplements for review?",
  ARE_YOU_SURE_YOU_WANT_TO_SEND_FOR_REVIEW: "Are you sure you want to send for review?",

  REPORT_NUMBER_FOR_AUDIT_GENERATED: "Report Number for this audit will be generated",

  YOU_MAY_WILL_LOSE_YOUR_DATA: "The changes that you made may not be saved",
  YOU_MAY_WILL_LOSE_YOUR_DATA_ON_CANCEL: "You may lose your data if you cancel",

  ASSIGN_TEAM_LEADER_TO_ANOTHER_TEAM_LEADER: "You are changing the Team Leader, Existing Team Leader role will default to Team Member",
  CANCEL: "Cancel",
  YES: "Yes",
  OK: "Ok",
  NO: "No",

  AUTHORIZATION_FROM_OTHER_SOCIETY_NOT_UPLOADED: "Authorization from other society is not uploaded",

  NO_DOCUMENT_AVAILABLE_REQUEST: "No documents were attached/uploaded during audit/survey request.",
  NO_DOCUMENT_AVAILABLE_SURVEY: "No documents were attached/uploaded during audit/survey.",
  NO_DOCUMENT_AVAILABLE_CLIENT: "No documents were attached/uploaded during client review.",
  NO_DOCUMENT_AVAILABLE_DGS: "No documents were attached/uploaded during report authorization.",
  NO_DOCUMENT_AVAILABLE_CERTIFICATE: "No documents were attached/uploaded during Prepare FT, Amend and Extend.",
  NO_DOCUMENT_AVAILABLE_DOC_REVIEW: "No documents were attached/uploaded during audit request review.",
  NO_DOCUMENT_AVAILABLE: "No documents were attached/uploaded.",

  DO_YOU_WANT_TO_LEAVE: "Do you want to leave the page?",

  AUTHORISATION_LETTER_SENT_TO_DGS: "Authorisation letter sent to DGS",
  FAILED_TO_SEND_AUTHORISATION_LETTER: "Failed to send authorisation letter",

  SAVE_DOCUMENT_PROGRESS: "Adding document",
  SAVE_DOCUMENT_FAILED: "Adding document failed",
  SAVE_DOCUMENT_SUCCESS: "Document added",

  SAVE_DOCUMENT_DETAILS_PROGRESS: "Adding document details",
  SAVE_DOCUMENT_DETAILS_FAILED: "Adding document details failed",
  SAVE_DOCUMENT_DETAILS_SUCCESS: "Document details added",

  PROCESS_MASTER_PROGRESS: "Saving process master details",
  PROCESS_MASTER_FAILED: "Failed to save process master details",
  PROCESS_MASTER_SUCCESS: "Process master details saved",

  FIELD_MASTER_PROGRESS: "Saving field master details",
  FIELD_MASTER_FAILED: "Failed to save field master details",
  FIELD_MASTER_SUCCESS: "Field master details saved",

  FOCUS_AREA_MASTER_PROGRESS: "Saving focus area master details",
  FOCUS_AREA_MASTER_FAILED: "Failed to save focus area master details",
  FOCUS_AREA_MASTER_SUCCESS: "Focus area master details saved",

  EXCLUSION_CLOSURE_PROGRESS: "Closing exclusion remarks",
  EXCLUSION_CLOSURE_FAILED: "Failed to close exclusion remarks",
  EXCLUSION_CLOSURE_SUCCESS: "Exclusion remarks closed",

  DOCUMENT_EXTRACTING: "Document Extracting",
  DOCUMENT_EXTRACTED: "Document Extracted",
  FAILED_DOCUMENT_EXTRACT: "Failed to Extract Document",

  DELETE_DOCUMENT_PROGRESS: "Removing document",
  DELETE_DOCUMENT_SUCCESS: "Document removed",
  DELETE_DOCUMENT_CONFIRMATION: "Do you want to remove this document?",
  DELETE_DOCUMENT_FAILED: "Failed to remove document",

  REJECT_CONTRACT_REVIEW_MESSAGE: "Contract Review will be rejected",
  REJECT_CONTRACT_REVIEW_PROGRESS: "Rejecting Contract Review",
  REJECT_CONTRACT_REVIEW_FAILED: "Failed to reject Contract Review",
  REJECT_CONTRACT_REVIEW_SUCCESS: "Contract Review rejected",

  ONHOLD_CONTRACT_REVIEW_MESSAGE: "Contract Review will be on hold",
  ONHOLD_CONTRACT_REVIEW_PROGRESS: "Placing Contract Review on hold",
  ONHOLD_CONTRACT_REVIEW_FAILED: "Failed to place Contract Review on hold",
  ONHOLD_CONTRACT_REVIEW_SUCCESS: "Contract Review On hold",

  CUSTOMER_REQUEST_CREATED: "Customer request created",
  CUSTOMER_REQUEST_SAVED: "Customer request saved",
  CUSTOMER_REQUEST_ACCEPTED: "Customer request accepted",
  CUSTOMER_REQUEST_SUBMITTED: "Customer request submitted",
  CUSTOMER_REQUEST_UPDATEDED: "Customer request updated",

  REQUEST_SUBMITTED_PROGRESS: "Request Submitting",
  REQUEST_SUBMIT_SUCCESS: "Request submitted",
  REQUEST_SUBMIT_FAILED: "Request submission failed",

  CUSTOMER_REQUEST_WILL_BE_CANCELLED: "Customer request will be cancelled",
  CANCELLED_CUSTOMER_REQUEST_PROGRESS: "Cancelling Customer Request",
  CANCELLED_CUSTOMER_REQUEST_SUCCESS: "Customer Request cancelled",
  CANCELLED_CUSTOMER_REQUEST_FAILED: "Cancelling Customer Request failed",

  EXCLUSION_CONFIRMATION: "Exclusion Remarks will be saved",
  EXCLUSION_REMARKS_PROGRESS: "Saving Exclusion Remarks",
  EXCLUSION_REMARKS_SUCCESS: "Exclusion Remarks saved",
  EXCLUSION_REMARKS_FAILED: "Saving Exclusion Remarks failed",

  PAC_PENDING_STATUS_CONFIRMATION: "PAC pending status remarks will be updated",
  PAC_PENDING_STATUS_REQUEST_PROGRESS: "Updating PAC pending status remarks",
  PAC_PENDING_STATUS_REQUEST_SUCCESS: "PAC pending status remarks updated",
  PAC_PENDING_STATUS_REQUEST_FAILED: "PAC pending status remarks failed",

  REJECT_CUSTOMER_REQUEST_MESSAGE: "Customer Request will be rejected",
  REJECT_CUSTOMER_REQUEST_PROGRESS: "Rejecting Customer Request",
  REJECT_CUSTOMER_REQUEST_FAILED: "Failed to reject Customer Request",
  REJECT_CUSTOMER_REQUEST_SUCCESS: "Customer Request rejected",

  ONHOLD_CUSTOMER_REQUEST_MESSAGE: "Customer Request will be on-hold",
  ONHOLD_CUSTOMER_REQUEST_PROGRESS: "On-Holding Customer Request",
  ONHOLD_CUSTOMER_REQUEST_FAILED: "Failed to on-hold Customer Request",
  ONHOLD_CUSTOMER_REQUEST_SUCCESS: "Customer Request on-hold",

  RETURN_CUSTOMER_REQUEST_PROGRESS: "Returning Survey Request",
  RETURN_CUSTOMER_REQUEST_FAILED: "Failed to return Survey Request",
  RETURN_CUSTOMER_REQUEST_SUCCESS: "Survey Request returned",

  CONTRACT_REVIEW_ACCEPTED: "Contract Review accepted",
  CONTRACT_REVIEW_CLIENT_SUBMITTED: "Your request has been submitted. We will get back to you at the earliest",
  CONTRACT_REVIEW_SAVED: "Contract Review saved",
  CONTRACT_REVIEW_UPDATED: "Contract Review updated",
  REQUEST_WILL_BE_SAVED_ALERT: "Request will be saved",
  REQUEST_WILL_BE_SUBMITTED_ALERT: "Request will be submitted",
  REQUEST_WILL_BE_UPDATED_ALERT: "Request will be updated",
  ACCEPT_AMENDMENT_REQUEST: "You want to accept amendment request audit?",
  CLIENT_REQUEST_SUBMITTED: "Request has been submitted",
  CLIENT_REQUEST_SAVED: "Request has been saved",
  SURVEY_REQUEST_SAVED: "Survey Request saved",

  AUDIT_ALREADY_ACCEPTED_ALERT: "You cannot make any changes as this audit is already “Accepted”.",
  AUDIT_REPORT_NO_GENERATED_ALERT: "You cannot make any changes as the Survey Report Number has generated.",
  LAST_MARK_DATE_ALERT: "You cannot make any changes as Last mark date was done.",

  REQUIRED_FIELD: "This field is required.",

  THIS_FIELD_SHOULD_GRETER_THAN: "This field should be greater than ",

  AMEND_AUTH_PROGRESS: "Sending amended authorisation letter",
  AMEND_AUTH_SUCCESS: "Amended authorisation letter sent",
  AMEND_AUTH_FAILED: "Failed to send amended authorisation letter",

  COMPLETE_AMEND_AUTH_PROGRESS: "Completing amended authorisation letter",
  COMPLETE_AMEND_AUTH_SUCCESS: "Amended authorisation letter completed",
  COMPLETE_AMEND_AUTH_FAILED: "Failed to complete amended authorisation letter",

  OLD_AUTH_LETTER_DELETING: "On Update, existing Authorization letter will be regenerated!",
  BSA_OLD_AUTH_LETTER_DELETING: "On Updating the Contract Review, existing Authorization letter will be regenerated!",
  DO_YOU_WANT_TO_REMOVE_THIS_AUDIT_DETAILS: "Do you want to remove this visit schedule entry?",
  DO_YOU_WANT_TO_REMOVE_THIS_VISIT_DETAIL: "Do you want to remove this visit detail?",
  DO_YOU_WANT_TO_REMOVE_THIS_SURVEYS: "Do you want to remove this Surveys?",
  DO_YOU_WANT_TO_REMOVE_THIS_SURVEY: "Do you want to remove this Survey?",

  DO_YOU_WANT_TO_REMOVE_THIS_BLOCK_PANEL: "Do you want to remove this Block and Panel?",
  BLOCK_PANEL_DELETED_PROGRESS: "Deleting Block and Panel details",
  BLOCK_PANEL_DELETED_SUCCESS: "Deleted Block and Panel details",
  BLOCK_PANEL_DELETED_FAILED: "Failed to delete Block and Panel details",

  DO_YOU_WANT_TO_REMOVE_THIS_TANK_SPACES: "Do you want to remove this Tank and Spaces?",
  TANK_SPACES_DELETED_PROGRESS: "Deleting Tanks and Spaces details",
  TANK_SPACES_DELETED_SUCCESS: "Deleted Tank and Spaces details",
  TANK_SPACES_DELETED_FAILED: "Failed to delete Tank and Spaces details",

  SAVING_AUDITORS_DETAILS: "Saving auditor details",
  AUDITORS_DETAILS_SAVED: "Auditor details saved",

  SAVING_SURVEYOR_DETAILS: "Saving surveyor details",
  SURVEYOR_DETAILS_SAVED: "Surveyor details saved",
  FAILED_TO_SURVEYOR_DETAILS_SAVED: "Failed to save Surveyor details",

  SAVING_BLOCK_FEE_DETAILS: "Saving block fee details",
  BLOCK_FEE_DETAILS_SAVED: "Block fee details saved",
  DO_YOU_WANT_TO_SAVE_THIS_SURVEYOR_DETAILS: "Do you want to save this surveyor details?",

  DO_YOU_WANT_TO_REMOVE_THIS_BLOCK_FEE_DETAILS: "Do you want to remove this block fee details?",
  DO_YOU_WANT_TO_REMOVE_THIS_AUDITOR_DETAILS: "Do you want to remove this auditor details?",
  DO_YOU_WANT_TO_REMOVE_THIS_SURVEYOR_DETAILS: "Do you want to remove this surveyor details?",
  DO_YOU_WANT_TO_REMOVE_THIS_DOCUMENT: "Do you want to remove this document?",

  SUBMITING_AUDITS_PROGRESS: "Saving audit visit schedule details",
  SUBMIT_AUDITS_SUCCESS: "Audit visit schedule details saved",

  SUBMITING_VISIT_DETAILS_PROGRESS: "Saving visit schedule details",
  SAVING_VISIT_DETAILS: "Saving Visit details",
  SUBMIT_VISIT_DETAILS_SUCCESS: "Visit details saved",

  THIS_FIELD_SHOULD_BE_PAST_DATE: "This field should be a past date",

  KINDLY_REFINE_THE_SEARCH_CRITERIA: "Kindly refine the search criteria",

  CONTRACT_REVIEW_WILL_BE_CANCELLED: "Contract Review will be cancelled",
  CANCELLED_CONTRACT_REVIEW_PROGRESS: "Cancelling Contract Review",
  CANCELLED_CONTRACT_REVIEW_SUCCESS: "Contract Review cancelled",
  CANCELLED_CONTRACT_REVIEW_FAILED: "Cancelling Contract Review failed",

  HO_EXAMINER_ASSIGNED: "HO Examiner has been successfully assigned.",
  HO_EXAMINER_REASSIGNED: "HO Examiner reassigned",
  HO_EXAMINER_REASSIGNING: "HO Examiner reassigning",

  PROJECT_REMARKS_ADDED: "Project remarks added",
  DELETE_REPORT_REMARK: "This remark will be deleted",

  DR_CHECKLIST_REMARKS: "Audit will return back to surveyor with remarks",
  DR_CHECKLIST_REMARKS_PROGRESS: "Adding remarks to document checklist",
  DR_CHECKLIST_REMARKS_FAILED: "Failed to Add remarks",
  DR_CHECKLIST_REMARKS_SUCCESS: "Added Remarks",

  SUBMIT_VISIT_DETAILS_FAILED: "Failed to save visit schedule details",

  BLOCK_FEE_DETAILS_SAVED_FAILED: "Failed to save block fee details",

  BLOCK_FEE_DETAILS_DELETE_PROGRESS: "Deleting block fee details",
  BLOCK_FEE_DETAILS_DELETED: "Deleted block fee detail",

  VISITED_DETAILS_DELETED_PROGRESS: "Deleting visit details",
  VISITED_DETAILS_DELETED_SUCCESS: "Deleted visit details",
  VISITED_DETAILS_FIRST_VISIT_WARNING: "We cannot delete First visit date",

  CONTRACT_REVIEW_ALREADY_ACCEPTED_ALERT: `You cannot make any changes as this Contract Review is 'Accepted'`,
  CONTRACT_REVIEW_ALREADY_REJECTED_ALERT: `You cannot make any changes as this Contract Review is 'Rejected'`,
  CONTRACT_REVIEW_ALREADY_PENDING_ALERT: `You cannot make any changes as this Contract Review is 'On Hold'`,
  CONTRACT_REVIEW_ASSIGNEE_NOT_AVAILABLE_ALERT: "You cannot make any changes as the examiner is not assigned yet",

  AUDITORS_DETAILS_DELETING: "Deleting auditor details",
  AUDITORS_DETAILS_DELETING_SUCESSS: "Auditor details deleted",
  AUDITORS_DETAILS_DELETE_FAILED: "Failed to delete auditor details",

  SURVEYORS_DETAILS_DELETING: "Deleting surveyor details",
  SURVEYORS_DETAILS_DELETING_SUCESSS: "Surveyor details deleted",
  SURVEYORS_DETAILS_DELETE_FAILED: "Failed to delete surveyor details",

  AUDITOR_REASSIGNED_SUCCESS: "Auditor reassigned",

  BLOCK_FEE_DELETED_FAILED: "Failed to delete block dee details",

  AUDIT_VISIT_DELETE_PROGRESS: "Deleting audit visit details",
  AUDIT_VISIT_DELETE_SUCCESS: "Deleted audit details",
  AUDIT_VISIT_DELETE_FAILED: "Failed to delete audit visit details",

  ADD_AUDITORS_FAILED: "At least one team leader must be assigned",
  ADD_ONLY_ONE_TEAM_LEADER: "Only one Team Leader is allowed.",
  ADD_SIGNATORY_AUDITORS_FAILED: "At least one signatory surveyor must be assigned",
  DUPLICATE_VISIT_DATE_ERROR: "Duplicate visit-dates not allowed",
  INLUCDE_MONITOR: "Please include Monitor in this audit",
  CHECK_ACTIVITY_MONITORING: "Please check value for Activity Monitoring",
  LIMIT_FOR_TRAINEE: "Upto 2 trainees can be assigned",
  ADD_BLOCK_FEE_FAILED: "Failed to add block fee details",
  ADD_VISIT_SCHEDULE_FAILED: "Failed to add audit visit details",
  OVERDUE_ERROR_MESSAGE_FOR_INTERIM: "Please select surveyor without overdue.",

  CONTRACT_REVIEW_ON_HOLD: "Contract Review marked 'On Hold'",
  CONTRACT_REVIEW_ON_HOLD_PROGRESS: "Marking Contract Review 'On Hold'",
  CONTRACT_REVIEW_ACCEPTED_PROGRESS: "Accepting Contract Review",
  CONTRACT_REVIEW_SAVED_PROGRESS: "Saving Contract Review",

  SURVEY_REQUEST_ACCEPTED_PROGRESS: "Accepting Survey Request",
  SURVEY_REQUEST_SAVED_PROGRESS: "Saving Survey Request",

  PLEASE_FILL_THE_SURVEY_TYPE: "Please fill the survey type",

  SEND_FOR_REVIEW_PROGRESS: "Sending for review",
  SEND_FOR_REVIEW_SUCCESS: "Sent for review",
  SEND_SUPP_CERTS_FOR_REVIEW_SUCCESS: "Certificates and Supplements are sent for review",
  SEND_FOR_REVIEW_FAILD: "Failed to sent for review",

  FORM_SUBMITTED: "Form submitted",
  FORM_COMPLETED: "Form completed",
  SUB_FORM_DELETED: "Form deleted",

  ERS_CHECKLIST_COMPLETED: "ERS Establishment Checklist completed",
  FAILED_TO_COMPLETE_ERS_CHECKLIST: "Failed  to complete ERS Establishment Checklist",
  INPROGRESS_ERS_CHECKLIST_COMPLETED: "Completing ERS Establishment Checklist ",

  CERTIFICATE_GENERATED: "Certificate Generated",
  INPROGRESS_CERTIFICATE_GENERATION: "Generating Certificate",
  FAILED_TO_GENERATE_CERTIFICATE: "Failed to Generate Certificate ",

  ONCE_THE_FORM_IS_SUBMITTED_IT_CANNOT_BE_EDITED_LATER: "Once the form is submitted, it cannot be edited later.",

  CONFIRM_REQUEST_DOCUMENT: "Are you sure you want to request these documents",

  NO_DETENTION_FOUND: "No Detention Details Found",
  NO_DEFICIENCES_FOUND: "No Deficiencies Found",

  VALIDATION_STRING_MSG: "The value must be string",
  VALIDATION_DATE_MSG: "The value must be date",
  VALIDATION_NUMBER_MSG: "The value must be numeric",
  VALIDATION_CHARACTER_MSG: "The value must be character",
  VALIDATION_BOOL_MSG: "The value must be bool",
  VALIDATION_DUPLICATE_VAL: "Duplicate values are not allowed",

  MARKING_LAST_DAY_OF_VISIT_PROGRESS: "Marking last day of visit",
  MARKING_LAST_DAY_OF_VISIT_SUCCESS: "Marked last day of visit",
  UNMARK_VISIT_SUCCESS: "Unmarked last day of visit",
  UNMARK_VISIT_PROGRESS: "Unmarking last day of visit",
  UNMARK_VISIT_FAILED: "Failed to unmark last day of visit",
  RM_APPROVAL_REQ_UNMARK_VISIT_SUCCESS: "Request created, please wait for approval",
  RM_APPROVAL_REQ_UNMARK_VISIT_PROGRESS: "Creating request",
  RM_APPROVAL_REQ_UNMARK_VISIT_FAILED: "Failed to create request",
  MARKING_LAST_DAY_OF_VISIT_FAILED: "Failed to marking last day of visit",
  MARKING_LAST_DAY_OF_VISIT_CONFIRMATION: "You need to mark last visit date of audit",
  UNMARKING_LAST_DAY_OF_VISIT_CONFIRMATION: "You need to unmark last visit date of audit",
  SEND_FOR_REVIEW_CONFIRMATION: "Supporting documents are not uploaded as per IOM. Do you still want to Send for Review?",
  SEND_FOR_REVIEW_CERT_CONFIRMATION: "Do you want to Send Certificate for Review?",
  SEND_FOR_REVIEW_CONFIRMATION_PCS: "Your reports are being submitted for review and you will be not able to make additional modifications.",
  SEND_FOR_REVIEW_CONFIRMATION_RPS: "Your reports are being submitted for review and you will be not able to make additional modifications.",
  SAVE_VISIT_WARNING: "Please Save the Visit Details",

  DELETE_ALL_DETAILS_CONFIRNATION: "All filled-in details will be removed. Do you still want to change the form category?",
  UPDATE_FORM_SELECTION_PROGRESS: "Updating Form Selection Details",
  UPDATE_FORM_SELECTION_SUCCESS: "Form Selection Details has been Updated",
  UPDATE_FORM_SELECTION_FAILED: "Updating Form Selection Details failed",
  SAVE_SCHEDULE_WARNING: "Please click on Schedule and save the form",
  QUALIFIED_AUDITOR: "Please select the qualified auditor only as Team Leader",
  SCHEDULE_TIME_SLOT_CONFLICT_WARNING: "Time conflict detected! An auditor cannot be assigned to overlapping time slots.",
  ONE_QUALIFIED_AUDITOR: "Please Include A Qualified Assessor!",

  SESSION_EXPIRED: {
    TITLE: "Session Expired.",
    HEADING: "You will be redirected to the Login page.",
  },

  ACCESS_DENIED_GENERATED_REPORT_NO: "Only allocated team members are permitted to generate report numbers",

  ACCESS_DENIED: {
    TITLE: "You are unauthorized to perform this action",
    HEADING: (
      <>
        You do not have permission to access this resource. Please check with <span className="uppercase">NAVGATH</span> Support Team.
      </>
    ),
  },

  TECHNICAL_ERROR: {
    TITLE: "Technical Error",
    HEADING: (
      <>
        Please try again later or check with <span className="uppercase">NAVGATH</span> Support Team.
      </>
    ),
  },
  APPROVE_REPORT_REVIEW_PROGRESS: "Approving for Report Review",
  APPROVE_REPORT_REVIEW_SUCCESS: "Report Review Approved",
  APPROVE_REPORT_REVIEW_FAILED: "Failed to Approve Report Review",

  APPROVE_AUDIT_REVIEW_PROGRESS: "Approving for Audit Report",
  APPROVE_AUDIT_REVIEW_SUCCESS: "Audit Review Approved",
  APPROVE_AUDIT_REVIEW_FAILED: "Failed to Approve Audit Report",

  TAWA_CLIENT_REQUEST_FORM_SUCCESS: "Your request has been submitted.  We will get back to you at the earliest.",
  TAWA_CLIENT_REQUEST_INPROGRESS: "Request in Progress.",

  AMEND_CERTIFICATE_CONFIRMATION: "Do you want to Amend the Full-Term Certificate",
  MXR_AMEND_CERTIFICATE_CONFIRMATION: "Do you want to Amend Certificate",
  AMEND_CERTIFICATE_PROGRESS: "Amending Certificate",
  AMEND_CERTIFICATE_SUCCESS: "Certificate is Amended",
  AMEND_CERTIFICATE_FAILED: "Failed to Amend Certificate",

  UPDATE_CERTIFICATE_PROGRESS: "Certificate is Updating",
  UPDATE_CERTIFICATE_SUCCESS: "Certificate is Updated",
  UPDATE_CERTIFICATE_FAILED: "Failed to Update Certificate",
  CERTIFICATE_NO_EXIST: "Certificate No Is Already Exist.",

  GENERATE_FT_CERTIFICATE_PROGRESS: "Generating Full-Term Certificate...",
  GENERATE_FT_CERTIFICATE: "Do you want to generate the Full-Term Certificate",
  GENERATE_FT_CERTIFICATE_SUCCESS: "Full-Term Certificate generated successfully.",
  GENERATE_FT_CERTIFICATE_FAILED: "Failed to generate the Full-Term Certificate.",

  UPDATE_FT_CERTIFICATE_PROGRESS: "Updating Full-Term Certificate...",
  UPDATE_FT_CERTIFICATE: "Do you want to Update the Full-Term Certificate",
  UPDATE_FT_CERTIFICATE_SUCCESS: "Full-Term Certificate Updated successfully.",
  UPDATE_FT_CERTIFICATE_FAILED: "Failed to Update the Full-Term Certificate.",

  ADD_CERTIFICATE_PROGRESS: "Certificate is Adding",
  ADD_CERTIFICATE_SUCCESS: "Certificate is Added",
  ADD_CERTIFICATE_FAILED: "Failed to Add Certificate",

  INVALIDATE_CERTIFICATE_CONFIRMATION: "The certificate will be invalidate and cannot be retrieved.",
  INVALIDATE_CERTIFICATE_PROGRESS: "Certificate is Invalidating",
  INVALIDATE_CERTIFICATE_SUCCESS: "Certificate is Invalidated",
  INVALIDATE_CERTIFICATE_FAILED: "Failed to Invalidate Certificate",

  ISSUE_DUPLICATE_CERT_PROGRESS: "Issuing Duplicate Certificate",
  ISSUE_DUPLICATE_CERT_FAILED: "Failed to Issue Duplicate Certificate",
  ISSUE_DUPLICATE_CERT_SUCCESS: "Duplicate Certificate is Issued",

  ISSUE_CERT_CONFIRMATION: "Do you want to issue the Full-Term Certificate",
  ISSUE_CERT_PROGRESS: "Issuing Certificate",
  ISSUE_CERT_FAILED: "Failed to Issue Certificate",
  ISSUE_CERT_SUCCESS: "Certificate is Issued",

  PREPARE_CERT_PROGRESS: "Preparing Certificate",
  PREPARE_CERT_FAILED: "Failed to Prepare Certificate",
  PREPARE_CERT_SUCCESS: "Certificate Prepared",

  ACITIVITY_MONITORING_SAVE_PROGRESS: "Saving Activity Monitoring Details",
  ACITIVITY_MONITORING_SAVE_SUCCESS: "Activity Monitoring Details Saved",
  ACITIVITY_MONITORING_SAVE_FAILED: "Saving of Activity Monitoring Failed",

  ACITIVITY_MONITORING_SUBMIT_PROGRESS: "Submitting Activity Monitoring Details",
  ACITIVITY_MONITORING_SUBMIT_SUCCESS: "Activity Monitoring Details Submitted",
  ACITIVITY_MONITORING_SUBMIT_FAILED: "Activity Monitoring Data Submission Failed",

  GENERATE_CERTIFICATE_PROGRESS: "Certificate is being generated",
  GENERATE_CERTIFICATE_SUCCESS: "Certificate is generated",
  GENERATE_CERTIFICATE_FAILED: "Failed to generate Certificate",
  GENERATE_CERTIFICATE_WARNING: "Please add atleast one digital signature",
  GENERATE_CERTIFICATE_WARNING_2: "Please add atleast one menu item",

  RESOLVE_REMARKS: "Please go back and resolve remarks before you submit form",

  INITIATE_PROJECT_STATUS: "Are you sure you want to Initiate Project?",
  UPDATE_PROJECT_STATUS_PROGRESS: "Updating Project Status",
  UPDATE_PROJECT_STATUS_FAILED: "Failed to Update Project Status",
  UPDATE_PROJECT_STATUS_SUCCESS: "Project Status Updated",

  ACITIVITY_MONITORING_APPROVE_PROGRESS: "Approving Activity Monitoring",
  ACITIVITY_MONITORING_APPROVE_SUCCESS: "Activity Monitoring Approved",
  MMSA_APPROVE_SUCCESS: "MMSA Record completed",
  MMSA_RECORD_APPROVED: "MMSA Record Approved",
  ACITIVITY_MONITORING_APPROVE_FAILED: "Activity Monitoring Approve Request Failed",
  MMSA_APPROVE_FAILED: "MMSA Record failed",
  REVIEWING_CERTIFICATE: "Reviewing Certificate",
  CERTIFICATE_REVIEWED_SUCCESS: "Certificate review completed",
  CERTIFICATE_REVIEWED_FAILED: "Failed to review certificate",
  SENDING_CERTIFICATE_REVIEW: "Sending certificate for review",
  MMSA_RETURNED_PROGRESS: "Returning MMSA Record",
  MMSA_RETURNED_SUCCESS: "MMSA Record Returned",
  MMSA_RETURNED_FAILED: "MMSA Record Returned Request Failed",
  ACITIVITY_MONITORING_RETURNED_PROGRESS: "Returning Activity Monitoring",
  ACITIVITY_MONITORING_RETURNED_SUCCESS: "Activity Monitoring Returned",
  ACITIVITY_MONITORING_RETURNED_FAILED: "Activity Monitoring Returned Request Failed",

  SURVEYOR_QUALIFICATION_APPROVE_PROGRESS: "Approving Surveyor Qualification",
  SURVEYOR_QUALIFICATION_APPROVED: "Surveyor Qualification Report Accepted",
  SURVEYOR_QUALIFICATION_FAILED: "Surveyor Qualification Report Failed to Accept ",

  SURVEYOR_QUALIFICATION_RETURNED_PROGRESS: "Returning Surveyor Qualification",
  SURVEYOR_QUALIFICATION_RETURNED_SUCCESS: "Surveyor Qualification Returned",
  SURVEYOR_QUALIFICATION_RETURNED_FAILED: "Surveyor Qualification Returned Request Failed",

  ACITIVITY_MONITORING_ACCEPT_PROGRESS: "Accepting Activity Monitoring",
  ACITIVITY_MONITORING_ACCEPT_SUCCESS: "Activity Monitoring Accepted",
  ACITIVITY_MONITORING_ACCEPT_FAILED: "Activity Monitoring Accept Request Failed",

  ACITIVITY_MONITORING_PASSTORM_PROGRESS: "Sending for RM Approval",
  ACITIVITY_MONITORING_PASSTORM_SUCCESS: "Sent for RM Approval",
  ACITIVITY_MONITORING_PASSTORM_FAILED: "Failed to send for RM Approval",

  ACITIVITY_MONITORING_RETURN_PROGRESS: "Returning Activity Monitoring",
  ACITIVITY_MONITORING_RETURN_SUCCESS: "Returned Successfully",
  ACITIVITY_MONITORING_RETURN_FAILED: "Return Failed",

  ACITIVITY_MONITORING_AMEND_PROGRESS: "Amending Activity Monitoring",
  ACITIVITY_MONITORING_AMEND_SUCCESS: "Amended Successfully",
  ACITIVITY_MONITORING_AMEND_FAILED: "Amend Failed",

  ACITIVITY_MONITORING_PREVIEW_PROGRESS: "Previewing the Activity Monitoring Report",
  ACITIVITY_MONITORING_PREVIEW_FAILED: "Failed to Preview Activity Monitoring Report",

  ANNUAL_REQUEST: "Are you sure you want to request Annual Audit?",
  RENEWAL_REQUEST: "Are you sure you want to request Renewal Audit?",
  AMENDMENT_REQUEST: "Are you sure you want to request Amendment Audit?",

  REQUEST_FAILED: "Request Failed",
  REQUEST_CONFLICT: "Request has some conflicts. Please check",
  AMENDMENT_REQUEST_CONFIRMATION: "Requested for Amendment, without involving the SS",

  COMPANY_BRANCHES_ADD_SUCCESS: "Company's Branch Added",
  COMPANY_EXIST_LIST: "The selected company already exists in the system. Please visit the listing page if you need to edit any information.",
  MANUFACTURING_UNIT_ADDED: "Manufacturing Unit added",
  COMPANY_BRANCHES_ADD_PROGRESS: "Adding Company's Branch",
  MANUFACTURING_UNIT_ADD_PROGRESS: "Adding Manufacturing Unit",
  COMPANY_BRANCHES_ADD_FAILED: "Failed to Add Company's Branch",
  MANUFACTURING_UNIT_ADD_SUCCESS: "Manufacturing Unit Added",
  MANUFACTURING_UNIT_ADD_FAILED: "Failed to Add Manufacturing Unit",

  REQUEST_FOR_CONTRACT_SUBMIT: "This Action will submit the request. Do you wish to proceed ?",

  TAWA_REQUEST: {
    FORM_SUCCESS: "Your request has been submitted. We will get back to you at the earliest.",
  },

  LAST_VISIT_DATE_FUTURE_DATE: "The last date of the survey should not be in the future",
  MARK_LAST_DATE_ISSUE: "Visit duration cannot be zero. Please update the visit time",
  FORM_SUBMIT_SUCCESS: "Form Submitted",
  FORM_SUBMIT_PROGRESS: "Submitting Form",
  FORM_SUBMIT_ERROR: "Failed to Submit Form",

  FORM_UPDATE_SUCCESS: "Form Updated",
  FORM_UPDATE_PROGRESS: "Updating Form",
  FORM_UPDATE_ERROR: "Failed to Update Form",

  AUDIT_CATEGORY_CHANGE_WARNING: "Due to change of survey type, your all uploaded documents will be moved into others document.",

  DELETE_CERTIFICATE_PROGRESS: "Deleting Digital Certificate",
  DELETE_CERTIFICATE_SUCCESS: "Digital Certificate deleted",
  DELETE_CERTIFICATE_FAILED: "Failed to delete Digital Certificate",
  DELETE_DIGITAL_CERTIFICATE_CONFIRMATION: "Digital Certificate will be deleted",
  DELETE_AMENDED_DIGITAL_CERTIFICATE_CONFIRMATION: "Amended Certificate will be deleted",

  SEND_DIGITAL_CERTIFICATE_PROGRESS: "Sending Digital Certificate",
  SEND_DIGITAL_CERTIFICATE_CONFIRMATION: "Digital Certificate will be sent",
  SEND_DIGITAL_CERTIFICATE_SUCCESS: "Digital Certificate Sent",
  SEND_DIGITAL_CERTIFICATE_FAILED: "Failed to send Digital Certificate",

  SEND_SRF_DOCUMENT_PROGRESS: "Sending SRF Document",
  SEND_SRF_DOCUMENT_SUCCESS: "SRF Document Sent",
  SEND_SRF_DOCUMENT_FAILED: "Failed to sending SRF Document",

  IS_DOWNLOADED_IN_DESKTOP: (report_no) => `${report_no} is downloaded in IR Navgath Desktop Application`,
  BLOCK_FEE_IN_MINUTE: (available, used) => `Available Block Fee ${available}. You entered ${used}.`,

  VALIDITY_EXCEEDS_MORE_THAN_5_YEARS: "Validity of certificate exceeds more than 5 years",

  DELETE_REPORT_NUMBER_PROGRESS: "Deleting Report Number",
  DELETE_REPORT_NUMBER_SUCCESS: "Report Number Deleted",
  DELETE_REPORT_NUMBER_FAILED: "Deleting Report Number Failed",

  SAVE_DESPATCH_LETTER_TEMPLATE_PROGRESS: "Saving Despatch letter template",
  SAVE_DESPATCH_LETTER_TEMPLATE_SUCCESS: "Despatch letter template saved",
  SAVE_DESPATCH_LETTER_TEMPLATE_FAILED: "Failed to save Despatch letter template",

  AUDIT_REMINDER_SENDING: "Sending Audit reminder",
  AUDIT_REMINDER_SENDED_SUCCESS: "Audit reminder sent",
  AUDIT_REMINDER_SENDING_FAILED: "Failed to send reminder",

  GENERATE_DIGITAL_REPORT_PROGRESS: "Digital Certificate is being generated",
  GENERATE_DIGITAL_REPORT_SUCCESS: "Digital Certificate is generated",
  GENERATE_DIGITAL_REPORT_FAILED: "Failed to generate Digital Certificate",
  GENERATE_DIGITAL_REPORT_WARNING: "Please add atleast one digital signature",

  PUBLISH_DIGITAL_REPORT_PROGRESS: "Digital Certificate is being publish",
  PUBLISH_DIGITAL_REPORT_SUCCESS: "Digital Certificate is published",
  PUBLISH_DIGITAL_REPORT_FAILED: "Failed to publish Digital Certificate",

  GENERATE_ESP_DIGITAL_REPORT_PROGRESS: "Digital Letter is being generated",
  GENERATE_ESP_DIGITAL_REPORT_SUCCESS: "Digital Letter is generated",
  GENERATE_ESP_DIGITAL_REPORT_FAILED: "Failed to generate Digital Letter",
  GENERATE_ESP_DIGITAL_REPORT_WARNING: "Please add atleast one digital signature",

  SEND_DIGITAL_ESP_LETTER_PROGRESS: "Sending Digital Letter",
  SEND_DIGITAL_ESP_LETTER_CONFIRMATION: "Digital Letter will be sent",
  SEND_DIGITAL_ESP_LETTER_SUCCESS: "Digital Letter Sent",
  SEND_DIGITAL_ESP_LETTER_FAILED: "Failed to send Digital Letter",

  DELETE_ESP_LETTER_PROGRESS: "Deleting Digital Certificate",
  DELETE_ESP_LETTER_SUCCESS: "Digital Certificate deleted",
  DELETE_ESP_LETTER_FAILED: "Failed to delete Digital Certificate",
  DELETE_DIGITAL_ESP_LETTER_CONFIRMATION: "Digital Certificate will be deleted",
  DELETE_AMENDED_DIGITAL_ESP_LETTER_CONFIRMATION: "Amended Certificate will be deleted",

  SRF_PROGRESS: "Saving Survey Request",
  CUSTOMER_REQUEST_PROGRESS: "Saving Customer request",
  SRF_SAVED: "Survey Request Saved",
  SRF_FAILED: "Failed to save Survey Request",
  SRF_ACCEPTED: "Survey Request accepted",
  CUSTOMER_REQUEST_FAILED: "Failed to save Customer request",
  EDIT_SRF_PROGRESS: "Editing Survey Request",
  EDIT_SRF_SUCCESS: "Survey Request Edited",
  EDIT_SRF_FAILED: "Failed to edit Survey Request",

  SURVEY_CATEGORIES_PROGRESS: "Saving survey categories in progress",
  SURVEY_CATEGORIES_SUCCESS: "Survey categories saved",
  SURVEY_CATEGORIES_FAILED: "Failed to save Survey Categories",
  SURVEY_CATEGORIES_ADDED_PROGRESS: "Adding survey categories in progress",
  SURVEY_CATEGORIES_ADDED_SUCCESS: "Survey categories added",
  SURVEY_CATEGORIES_ADDED_FAILED: "Failed to add Survey Categories",

  SURVEYORS_ASSIGN_SUCCESS: "Surveyors Assigned",
  SURVEYORS_ASSIGN_FAILED: "Failed to assign Surveyors",
  SURVEYORS_ASSIGN_PROGRESS: "Surveyor Assignment in progress",
  ELIGABLE_SURVEYORS_REQUIRED: "Atleast one qualified Surveyor is required",

  DELETE_SURVEYES_SUCCESS: "Surveys deleted successfully",
  DELETE_SURVEYES_FAILED: "Failed to delete Surveys",
  DELETE_SURVEYES_PROGRESS: "Deletion of Surveys in progress",

  REJECTING_SURVEYE_DELETION_REQUEST_SUCCESS: "Survey deletion request is rejected",
  REJECTING_SURVEYE_DELETION_REQUEST_FAILED: "Failed to reject survey deletion request",
  REJECTING_SURVEYE_DELETION_REQUEST_PROGRESS: "Rejecting survey deletion request in progress",

  SURVEY_TEAM_PROGRESS: "Saving survey team in progress",
  SURVEY_TEAM_SUCCESS: "Survey team saved",
  SURVEY_TEAM_FAILED: "Failed to save survey team",
  ASSIGN_TEAM_LEADER_FAILED: "Please assign New Team Leader",

  FLAG_AUTHORIZATION_REQUIRED_FOR_OVERDUE_STATUTORY: "Flag Authorization required for overdue Statutory Surveys",
  GESIP_AUTO_ADDED_MESSAGE: "For All Foreign going vessel which gross tonnage more then 500 GENEXSIP will be auto added",

  RECOMMENDATION_SAVE_PROGRESS: "Saving Survey Daily Report (SRS)",
  RECOMMENDATION_SAVE_SUCCESS: "Survey Daily Report (SRS) Saved",
  RECOMMENDATION_SAVE_FAILED: "Failed to save Survey Daily Report (SRS)",

  SHIP_STATUS_CHANGE_CONFIRMATION: "Are you sure you want to change the ship status?",
  SHIP_SURVEY_STATUS_SAVE_PROGRESS: "Saving Ship Status",
  SHIP_SURVEY_STATUS_SAVE_SUCCESS: "Ship Status Saved",
  SHIP_SURVEY_STATUS_SAVE_FAILED: "Failed to save Ship Status",

  OBSERVATION_CLOSURE_PROGRESS: "Closing Observation",
  OBSERVATION_CLOSURE_SUCCESS: "Observation Closed",
  OBSERVATION_CLOSURE_FAILED: "Failed to Close Observation",

  SURVEY_VISIT_REPORT_SAVE_PROGRESS: "Saving Survey Visit Report",
  SURVEY_VISIT_REPORT_SAVE_SUCCESS: "Survey Visit Report Saved",
  SURVEY_VISIT_REPORT_SAVE_FAILED: "Failed to save Survey Visit Report",

  SURVEY_VISIT_REPORT_PUBLISH_PROGRESS: "Publishing Survey Visit Report",
  SURVEY_VISIT_REPORT_PUBLISH_SUCCESS: "Survey Visit Report Published",
  SURVEY_VISIT_REPORT_PUBLISH_FAILED: "Failed to publish Survey Visit Report",

  PROGRESS_SAVE_PROGRESS: "Saving Survey Progress Report",
  PROGRESS_SAVE_SUCCESS: "Survey Progress Report Saved",
  PROGRESS_SAVE_FAILED: "Failed to save Survey Progress Report",

  RECOMMENDATION_DELETE_PROGRESS: "Deleting Survey Daily Report (SRS)",
  RECOMMENDATION_DELETE_SUCCESS: "Survey Daily Report (SRS) Deleted",
  RECOMMENDATION_DELETE_FAILED: "Failed to delete Survey Daily Report (SRS)",

  PROGRESS_DELETE_PROGRESS: "Deleting Survey Progress Report",
  PROGRESS_DELETE_SUCCESS: "Survey Progress Report Deleted",
  PROGRESS_DELETE_FAILED: "Failed to delete Survey Progress Report",

  RECOMMENDATION_DELETE_CONFIRMATION: "Are you sure you want to delete this report?",
  FILE_DELETE_CONFIRMATION: "Are you sure you want to delete this file?",
  PROGRESS_DELETE_CONFIRMATION: "Are you sure you want to delete this progress report?",

  QS_REJECT_CONFIRMATION: "Are you sure you want to reject this qualification survey?",
  QS_REJECT_SUCCESS_CONFIRMATION: "Qualification Survey has been rejected",
  QS_DELETE_CONFIRMATION: "Are you sure you want to delete this qualification survey?",
  QS_DELETE_SUCCESS_CONFIRMATION: "Qualification Survey has been deleted",
  QS_DELETE_FAILED: "Failed to delete qualification survey",
  QS_APPROVAL_PROGRESS: "Approval in Progress",
  QS_APPROVAL_SUCCESS: "Qualification Survey has been approved",
  QS_APPROVAL_FAILED: "Failed to approve qualification survey",
  QS_SAVE_PROGRESS: "Saving qualification survey",
  QS_SAVE_SUCCESS: "Qualification survey saved",
  QS_SAVE_FAILED: "Failed to save qualification survey",
  QS_ALREADY_QUALIFIED: "Surveyor is already qualified for the selected survey group.",

  MS_DELETE_CONFIRMATION: "Are you sure you want to delete this mentoring survey?",
  MS_DELETE_SUCCESS_INPROGRESS: "Deleting Mentoring Survey",
  MS_DELETE_SUCCESS_CONFIRMATION: "Mentoring Survey has been deleted",
  MS_DELETE_FAILED: "Failed to delete mentoring survey",

  GUIDANCE_SAVE_PROGRESS: "Saving guidance remarks",
  GUIDANCE_SAVE_SUCCESS: "Guidance remarks saved",
  GUIDANCE_SAVE_FAILED: "Failed to save guidance remarks",

  MS_SAVE_PROGRESS: "Saving mentoring survey",
  MS_SAVE_SUCCESS: "Mentoring survey saved",
  MS_SAVE_FAILED: "Failed to save mentoring survey",

  REGISTRING_USER: "Registering user",
  USER_REGISTERED: "You have successfully registered.",

  FAILED_TO_SUBMIT_CAPTCHA: "Failed to submit captcha",

  REJECT_CLIENT_REGISTRATION_MESSAGE: "Client registration  will be rejected",
  REJECT_CLIENT_REGISTRATION_PROGRESS: "Rejecting Client registration",
  CLIENT_REGISTRATION_FAILED: "Failed to reject Client registration",
  REJECT_CLIENT_REGISTRATION_SUCCESS: "Client registration rejected",

  CLIENT_REGISTRATION_PROGRESS: "Saving client registration",
  CLIENT_REGISTRATION_SUCCESS: "Client Registration Accepted",
  CLIENT_REGISTRATION_FAILED_TO_ACCEPT: "Failed to accept client registration",

  CHANGE_PASSWORD_PROGRESS: "Updating password",
  CHANGE_PASSWORD_SUCCESS: "Password changed successfully",
  CHANGE_PASSWORD_FAILED: "Failed to update password Please try again",

  FORGET_PASSWORD_PROGRESS: "Forget password in progress",
  FORGET_PASSWORD_SUCCESS: "We've sent a temporary password to your email. Kindly log using new password",
  FORGET_PASSWORD_FAILED_TO_ACCEPT: "Failed to forget password",

  GENERATE_SURVEY_REPORT: "Inspection Report Saved",
  GENERATE_SURVEY_REPORT_PROGRESS: "Inspection Report Generated",
  DO_YOU_WANT_TO_CREATE_REPORT_HEADER: "Do you want to create Inspection Report?",

  CANCELLED_REPORT_HEADER_PROGRESS: "Cancelling Reporting",
  CANCELLED_REPORT_HEADER_SUCCESS: "Reporting cancelled",
  CANCELLED_REPORT_HEADER_FAILED: "Report Cancelling failed",

  CMCIP_VESSEL:
    'Vessel Identified under "Condition Monitoring" dtd 16/11/2023, Confirmatory survey is required to access the condition of vessel under condition monitoring program',

  LOADING: "Loading",

  UPDATE_REPORT_REVIEW_STATUS_PROGRESS: "Updating Report Review Status",
  UPDATE_REPORT_REVIEW_STATUS_SUCCESS: "Report Review Status updated",
  UPDATE_REPORT_REVIEW_STATUS_FAILED: "Failed to Update Report Review Status",
  BSA_DISABLED_VIEW_REPORT_TOOLTIP: "You can view the reports after picking this audit for review",
  BSA_DISABLED_REVIEW_COMPLETE: "Close the open remarks to complete the review.",

  MC_SURVEY_PLAN_DELETE_CONFIRMATION: "Are you sure you want to delete this Survey Plan",
  MC_SURVEY_PLAN_SUCCESS_INPROGRESS: "Deleting Survey Plan",
  MC_SURVEY_PLAN_SUCCESS: "Survey Plan has been deleted",
  MC_SURVEY_PLAN_FAILED: "Failed to delete Survey Plan",

  CREATE_NOTE_FAILED: "Failed to save note",
  UPDATE_NOTE_FAILED: "Failed to update note",
  CREATE_NOTE_SUCCESS: "Note saved successfully",
  CREATE_NOTE_PROGRESS: "Saving note",
  DELETE_NOTE_FAILED: "Failed to delete note",
  DELETE_NOTE_SUCCESS: "Note deleted successfully",
  DELETE_NOTE_PROGRESS: "Deleting note",

  MARKING_LAST_DAY_OF_VISIT_SURVEY_CONFIRMATION: "You need to mark last visit date of survey",
  UNMARKING_LAST_DAY_OF_VISIT_SURVEY_CONFIRMATION: "You need to unmark last visit date of survey",
  UNMARKING_LAST_DAY_OF_VISIT_SURVEY_CONFIRMATION_AFTER_72HOURS: "Are you sure want to request RM for the approval to Revert Ship Survey Status?",

  MARK_LAST_DAY_OF_VISIT_INSPECTION_CONFIRMATION: "You need to mark last visit date of inspection",
  UNMARK_LAST_DAY_OF_VISIT_INSPECTION_CONFIRMATION: "You need to unmark last visit date of inspection",

  SAVE_SURVEYS_PROGRESS: "Saving Surveys",
  SAVE_SURVEYS_SUCCESS: "Surveys saved",
  SAVE_SURVEYS_FAILED: "Failed to save Surveys",
  IS_DELETED_IN_CASE_CSH_WARNING: "IS to be deleted in case CSH is to be marked completed.",
  CLASSIFICATION_SSH_CSH_REQUIRED: "SSH or CSH category is required. Please add from External Survey option.",

  SAVE_SURVEY_SCOPE_TYPES_PROGRESS: "Saving Survey Scope Types",
  SAVE_SURVEY_SCOPE_TYPES_SUCCESS: "Survey Scope Types saved",
  SAVE_SURVEY_SCOPE_TYPES_FAILED: "Failed to save Survey Scope Types",

  SAVE_LAIDPU_PROGRESS: "Saving Lay up request type",
  SAVE_LAIDUP_TYPES_SUCCESS: "Lay up Types saved",
  SAVE_LAIDUP_TYPES_FAILED: "Failed to save lay up Types",

  SAVE_CERTIFICATE_PROGRESS: "Saving Certificate",
  SAVE_CERTIFICATE_SUCCESS: "Certificate saved",
  SAVE_CERTIFICATE_FAILED: "Failed to save Certificate",

  EDIT_CERTIFICATE_PROGRESS: "Editing Certificate",
  EDIT_CERTIFICATE_SUCCESS: "Certificate edited",
  EDIT_CERTIFICATE_FAILED: "Failed to edit Certificate",

  DELETE_SURVEY_CERTIFICATE_PROGRESS: "Deleting Certificate",
  DELETE_SURVEY_CERTIFICATE_SUCCESS: "Certificate deleted",
  DELETE_SURVEY_CERTIFICATE_FAILED: "Failed to delete Certificate",

  SAVE_ITEM_UPDATE_PROGRESS: "Item Update in progress",
  SAVE_ITEM_UPDATE_SUCCESS: "Item Updated",
  SAVE_ITEM_UPDATE_FAILED: "Failed to update item",

  CONFIRM_ML_TEMPLATE_ITEM_CHANGES: "The previous changes will be removed and cannot be restored.",
  SAVE_ML_TEMPLATE_PROGRESS: "ML Item Template Save in progress",
  SAVE_ML_TEMPLATE_SUCCESS: "ML Item Template Saved",
  SAVE_ML_TEMPLATE_FAILED: "Failed to save ML Item Template",

  SURVEY_MACHINERY_PROGRESS_PROGRESS: "Machinery/Electrical Progress Save in progress",
  SURVEY_MACHINERY_PROGRESS_SUCCESS: "Machinery/Electrical Progress Saved",
  SURVEY_MACHINERY_PROGRESS_FAILED: "Failed to save Machinery/Electrical Progress",

  SURVEY_BLOCK_PROGRESS_PROGRESS: "Block/Panel data save in progress",
  SURVEY_BLOCK_PROGRESS_SUCCESS: "Block/Panel data saved",
  SURVEY_BLOCK_PROGRESS_FAILED: "Failed to save Block/Panel data",

  SURVEY_EQUIPMENT_CERT_PROGRESS_PROGRESS: "Equipment Certification Status data save in progress",
  SURVEY_EQUIPMENT_CERT_PROGRESS_SUCCESS: "Equipment Certification Status data saved",
  SURVEY_EQUIPMENT_CERT_PROGRESS_FAILED: "Failed to save Equipment Certification Status data",

  TANK_SPACES_PROGRESS: "Tanks & Spaces - Survey Status Save in progress",
  TANK_SPACES_SUCCESS: "Tanks & Spaces - Survey Status Saved",
  TANK_SPACES_FAILED: "Failed to save Tanks & Spaces - Survey Status",

  PRELAUNCH_ACTIVITIES_PROGRESS: "Pre-Launch Activities Save in progress",
  PRELAUNCH_ACTIVITIES_SUCCESS: "Pre-Launch Activities Saved",
  PRELAUNCH_ACTIVITIES_FAILED: "Failed to save Pre-Launch Activities",

  REQUEST_HO_CLEARANCE_PROGRESS: "HO Clearance request in progress",
  REQUEST_HO_CLEARANCE_SUCCESS: "HO Clearance requested",
  REQUEST_HO_CLEARANCE_FAILED: "Failed to HO Clearance request",

  REQUEST_ICC_CLEARANCE_PROGRESS: "ICC Clearance request in progress",
  REQUEST_ICC_CLEARANCE_SUCCESS: "ICC Clearance requested",
  REQUEST_ICC_CLEARANCE_FAILED: "Failed to ICC Clearance request",

  HO_CLEARANCE_DECLARED_PROGRESS: "HO Clearance declare in progress",
  HO_CLEARANCE_DECLARED_SUCCESS: "HO Clearance declared",
  HO_CLEARANCE_DECLARED_FAILED: "Failed to declare HO Clearance",

  ICC_CLEARANCE_DECLARED_PROGRESS: "ICC Clearance declare in progress",
  ICC_CLEARANCE_DECLARED_SUCCESS: "ICC Clearance declared",
  ICC_CLEARANCE_DECLARED_FAILED: "Failed to declare ICC Clearance",

  SS_CLEARANCE_DECLARED_PROGRESS: "SS Clearance declare in progress",
  SS_CLEARANCE_DECLARED_SUCCESS: "SS Clearance declared",
  SS_CLEARANCE_DECLARED_FAILED: "Failed to declare SS Clearance",

  CONFIRM_TYPE_OF_ENGINE_CHANGE:
    "The previously applied configuration and saved items will be removed permanently and cannot be restored once you saved the data.",

  CONFIRM_REVERT_MLITEM: "The ML Items will be deleted and cannot be retrieved",
  REVERT_MLITEM_PROGRESS: "Reverting ML Items in progress",
  REVERT_MLITEM_SUCCESS: "ML Items Reverted",
  REVERT_MLITEM_FAILED: "Failed to Revert ML Items",

  CONFIRM_PUBLISH_MLITEM: "The ML Items will be published",
  PUBLISH_MLITEM_PROGRESS: "Publish ML Items in progress",
  PUBLISH_MLITEM_SUCCESS: "ML Items Published",
  PUBLISH_MLITEM_FAILED: "Failed to Publish ML Items",

  CONFIRM_HOLD_MLITEM: "The ML Item will be marked as On Hold.",
  HOLD_MLITEM_PROGRESS: "Setting ML Item status to On Hold",
  HOLD_MLITEM_SUCCESS: "The ML Item has been set to On Hold.",
  HOLD_MLITEM_FAILED: "Failed to Hold ML Items",

  SAVE_ADDITIONAL_INFORMATIONS_PROGRESS: "Saving Additional Information",
  SAVE_ADDITIONAL_INFORMATIONS_SUCCESS: "Additional information saved",
  SAVE_ADDITIONAL_INFORMATIONS_FAILED: "Failed to save Additional Information",

  SAVE_STATUTORY_CONDITION_PROGRESS: "Saving Statutory Condition",
  SAVE_STATUTORY_CONDITION_SUCCESS: "Statutory Condition saved",
  SAVE_STATUTORY_CONDITION_FAILED: "Failed to save Statutory Condition",

  SAVE_PCS_FSI_DEFICIENCIES_PROGRESS: "Saving PSC FSI Deficiencies",
  SAVE_PCS_FSI_DEFICIENCIES_SUCCESS: "PSC FSI Deficiencies saved",
  SAVE_PCS_FSI_DEFICIENCIES_FAILED: "Failed to save PSC FSI Deficiencies",

  SAVE_NEW_REQUIREMENTS_PROGRESS: "Saving New requirements",
  SAVE_NEW_REQUIREMENTS_SUCCESS: "New requirements saved",
  SAVE_NEW_REQUIREMENTS_FAILED: "Failed to save New requirements",

  SAVE_MEMORANDA_PROGRESS: "Saving Memoranda",
  SAVE_MEMORANDA_SUCCESS: "Memoranda saved",
  SAVE_MEMORANDA_FAILED: "Failed to save Memoranda",

  SAVE_CONDITION_OF_CLASS_PROGRESS: "Saving Condition of Class",
  SAVE_CONDITION_OF_CLASS_SUCCESS: "Condition of Class saved",
  SAVE_CONDITION_OF_CLASS_FAILED: "Failed to save Condition of Class",

  SAVE_ITEM_ADD_PROGRESS: "Adding ML Item",
  SAVE_ITEM_ADD_SUCCESS: "ML Item Added",
  SAVE_ITEM_ADD_FAILED: "Failed to add ML Item",

  UPDATE_ITEM_ADD_PROGRESS: "Updating ML Item",
  UPDATE_ITEM_ADD_SUCCESS: "ML Item Updated",
  UPDATE_ITEM_ADD_FAILED: "Failed to update ML Item",

  DELETE_ITEM_ADD_PROGRESS: "Deleting ML Item",
  DELETE_ITEM_ADD_SUCCESS: "ML Item Deleted",
  DELETE_ITEM_ADD_FAILED: "Failed to delete ML Item",

  APPROVE_EXTENSION_REQUEST_OF_CONDITION_OF_CLASS_PROGRESS: "Approving extension request for Condition of Class",
  APPROVE_EXTENSION_REQUEST_OF_CONDITION_OF_CLASS_SUCCESS: "Condition of Class extension request approved",
  APPROVE_EXTENSION_REQUEST_OF_CONDITION_OF_CLASS_FAILED: "Failed to approve Condition of Class extension request",

  SHIP_REQUEST_SUCCESS:
    "Thank you for submitting your vessel details. You will now be logged out. Our support team will contact you soon to assist with your request.",

  SURVEY_QUALIFICATION_ACCEPT_PROGRESS: "Accepting Surveyor Qualification",
  SURVEY_QUALIFICATION_ACCEPT_SUCCESS: "Surveyor Qualification Report Accepted",
  SURVEY_QUALIFICATION_ACCEPT_FAILED: "Surveyor Qualification Accept Request Failed",

  SURVEY_QUALIFICATION_APPROVE_PROGRESS: "Approving Surveyor Qualification",
  SURVEY_QUALIFICATION_APPROVE_SUCCESS: "Surveyor Qualification Approved",
  SURVEY_QUALIFICATION_APPROVE_FAILED: "Surveyor Qualification Approve Request Failed",

  SURVEY_QUALIFICATION_PASSTORM_PROGRESS: "Sending for RM Approval",
  SURVEY_QUALIFICATION_PASSTORM_SUCCESS: "Sent for RM Approval",
  SURVEY_QUALIFICATION_PASSTORM_FAILED: "Failed to send for RM Approval",

  SURVEY_QUALIFICATION_PREVIEW_PROGRESS: "Previewing the Surveyor Qualification Report",
  SURVEY_QUALIFICATION_PREVIEW_FAILED: "Failed to Preview Surveyor Qualification Report",

  DELETE_DIGITAL_REPORT_CONFIRMATION: "The digital certificate will be deleted and cannot be retrieved",
  DELETE_REPORT_PROGRESS: "Deleting Digital Certificate",
  DELETE_DIGITAL_REPORT_SUCCESS: "Digital Certificate deleted",
  DELETE_DIGITAL_REPORT_FAILED: "Failed to delete Digital Certificate",

  THIS_FIELD_CANNOT_BE_MORE_THAN_4000_CHARACTERS: "This field cannot be more than 4000 characters",
  THIS_FIELD_CANNOT_BE_MORE_THAN_500_CHARACTERS: "This field cannot be more than 500 characters",

  REQUEST_SEND_FOR_REVIEW_PROGRESS: "Sending request for review",
  REQUEST_SEND_FOR_REVIEW_SUCCESS: "Request is under review",
  REQUEST_SEND_FOR_REVIEW_FAILED: "Failed to send for review",
  REQUEST_APPROVE_REQ_PROGRESS: "Approving request",
  REQUEST_APPROVE_REQ_SUCCESS: "Request approved",
  REQUEST_APPROVE_REQ_FAILED: "Failed to approve request",
  REQUEST_PROGRESS: "Saving request",
  REQUEST_SAVED: "Request Saved",
  REQUEST_DELETE_SURVEY_PROGRESS: "Deleting survey",
  REQUEST_DELETE_SURVEY_SUCCESS: "Survey Deleted",
  REQUEST_DELETE_SURVEY_FAILED: "Failed to delete survey",

  MLC_CSTL_VESSEL_EXPIRED: "The Certificate is overdue for this Vessel. Click on Send to HO for Overdue Concurrence Approval.",
  MAIL_HAS_BEEN_SENT_TO_MLC_CELL_HEAD: "Email has been sent to MLC Cell HO",
  CONCURRENCE_APPROVAL_FAILED: "Concurrence approval failed",
  CONCURRENCE_APPROVAL_SUCCESSFUL: "Concurrence approval successful",
  CONCURRENCE_APPROVAL_INPROGRESS: "Concurrence approval in progress",

  NC_RETURNED: "NC Returned",
  NC_RETURNED_FAILED: "Failed to return NC",

  UNMARKING_SS_REVIEWER_CONFIRM: "The Report will be available to be picked again for review.",
  UNMARKING_SS_REVIEWER: "Unmarking SS Reviewer",
  UNMARKING_SS_REVIEWER_SUCCESS: "SS Reviewer unmarked",
  UNMARKING_SS_REVIEWER_FAILED: "Failed to Unmark SS Reviewer",

  UNMARKING_HO_REVIEWER_SUCCESS: "HO Reviewer Unmarked",
  UNMARKING_HO_REVIEWER: "Unmarking HO Reviewer",

  SELF_REVIEW_NOT_ALLOWED: "Self Review not allowed",

  SAVE_PR17_REPORTING_PROGRESS: "Saving PR17 report",
  SAVE_PR17_REPORTING_SUCCESS: "PR17 report saved",
  SAVE_PR17_REPORTING_FAILED: "Failed to save PR17 report",

  SUBMIT_PR17_REPORTING_PROGRESS: "Submitting PR17 report",
  SUBMIT_PR17__SEND_FOR_REVIEW_REPORTING_SUCCESS: "PR17 report submitted for review",
  SUBMIT_PR17_REPORTING_SUCCESS: "PR17 report submitted",
  SUBMIT_PR17_REPORTING_FAILED: "Failed to submit PR17 report",

  SAVE_PR17_SCRUTINY_REPORTING_PROGRESS: "Saving PR17 scrutiny report",
  SAVE_PR17_SCRUTINY_REPORTING_SUCCESS: "PR17 scrutiny report saved",
  SAVE_PR17_SCRUTINY_REPORTING_FAILED: "Failed to save PR17 scrutiny report",

  SUBMIT_PR17_SCRUTINY_REPORTING_PROGRESS: "Submitting PR17 scrutiny report",
  SUBMIT_PR17_SCRUTINY__SEND_FOR_REVIEW_REPORTING_SUCCESS: "PR17 scrutiny report submitted for review",
  SUBMIT_PR17_SCRUTINY_REPORTING_SUCCESS: "PR17 scrutiny report submitted",
  SUBMIT_PR17_SCRUTINY_REPORTING_FAILED: "Failed to submit PR17 scrutiny report",

  SAVE_CHECKLIST_PROGRESS: "Saving checklist",
  SAVE_CHECKLIST_SUCCESS: "Checklist saved",
  SAVE_CHECKLIST_FAILED: "Failed to save checklist",

  EXAMINER_ASSIGNED: "Examiner has been successfully assigned",
  EXAMINER_ASSIGNING: "Assigning Examiner",
  FAILED_TO_ASSIGN_EXAMINER: "Failed to assigned Examiner",

  PLAN_COMPLETION_IN_PROGRESS: "Completing Plan",
  PLAN_COMPLETION_IN_SUCCESS: "Plan Completed",
  PLAN_COMPLETION_FAILED: "Failed to Complete Plan",

  SUBMIT_SERVICE_REQUEST_PROGRESS: "Submitting Service Request",
  SUBMIT_SURVEY_REQUEST_PROGRESS: "Submitting Survey Request",
  SUBMIT_SERVICE_REQUEST_SUCCESS: "Service Request Submitted",
  SUBMIT_SERVICE_REQUEST_FAILED: "Failed to Submit Service Request",
  SUBMIT_SURVEY_SERVICE_REQUEST_SUCCESS: "Survey Request Submitted",
  SUBMIT_SURVEY_REQUEST_FAILED: "Failed to Submit Survey Request",
  SUBMIT_MODEL_PROGRESS: "Submitting Models",
  SUBMIT_MODEL_SUCCESS: "Upload Models Complete",
  SUBMIT_MODEL_FAILED: "Failed to Submit Model",

  SERVICE_REQUEST_WILL_BE_CANCELLED: "Service Request will be cancelled",
  SURVEY_REQUEST_WILL_BE_CANCELLED: "Survey Request will be cancelled",
  CANCELLED_SERVICE_REQUEST_PROGRESS: "Cancelling Service Request",
  CANCELLED_SERVICE_REQUEST_SUCCESS: "Service Request cancelled",
  CANCELLED_SERVICE_REQUEST_FAILED: "Cancelling Service Request failed",
  CANCELLED_SURVEY_REQUEST_PROGRESS: "Cancelling Survey Request",
  CANCELLED_SURVEY_REQUEST_SUCCESS: "Survey Request cancelled",
  CANCELLED_SURVEY_REQUEST_FAILED: "Cancelling Survey Request failed",

  SERVICE_REQUEST_WILL_BE_REJECTED: "Service request will be rejected",
  SURVEY_REQUEST_WILL_BE_REJECTED: "Survey request will be rejected",
  REJECTED_SERVICE_REQUEST_PROGRESS: "Rejecting Service Request",
  REJECTED_SERVICE_REQUEST_SUCCESS: "Service Request rejected",
  REJECTED_SERVICE_REQUEST_FAILED: "Rejecting Service Request failed",
  REJECT_SURVEY_REQUEST_MESSAGE: "Survey Request will be rejected",
  REJECTED_SURVEY_REQUEST_PROGRESS: "Rejecting Survey Request",
  REJECTED_SURVEY_REQUEST_SUCCESS: "Survey Request rejected",
  REJECTED_SURVEY_REQUEST_FAILED: "Rejecting Survey Request failed",

  SERVICE_REQUEST_WILL_BE_ON_HOLD: "Service request will be on hold",
  ON_HOLD_SERVICE_REQUEST_PROGRESS: "Holding Service Request",
  ON_HOLD_SERVICE_REQUEST_SUCCESS: "Service Request is on hold",
  ON_HOLD_SERVICE_REQUEST_FAILED: "Holding Service Request failed",

  SURVEY_REQUEST_WILL_BE_ON_HOLD: "Survey request will be on hold",
  ON_HOLD_SURVEY_REQUEST_PROGRESS: "Holding Survey Request",
  ON_HOLD_SURVEY_REQUEST_SUCCESS: "Survey Request is on hold",
  ON_HOLD_SURVEY_REQUEST_FAILED: "Holding Survey Request failed",

  ACCEPTED_SERVICE_REQUEST_PROGRESS: "Accepting Service Request",
  ACCEPTED_SERVICE_REQUEST_SUCCESS: "Service Request Accepted",
  ACCEPTED_SERVICE_REQUEST_FAILED: "Failed to accepted Service Request",

  ACCEPTED_SURVEY_REQUEST_PROGRESS: "Accepting Survey Request",
  UPDATE_SURVEY_REQUEST_PROGRESS: "Updating Survey Request",
  ACCEPTED_SURVEY_REQUEST_SUCCESS: "Survey Request Accepted",
  UPDATED_SURVEY_REQUEST_SUCCESS: "Survey Request Updated",
  ACCEPTED_SURVEY_REQUEST_FAILED: "Failed to accept Survey Request",
  UPDATED_SURVEY_REQUEST_FAILED: "Failed to update Survey Request",

  SAVE_SERVICE_REQUEST_PROGRESS: "Saving Service Request",
  SAVE_SERVICE_REQUEST_SUCCESS: "Service Request Saved",
  SAVE_SERVICE_REQUEST_FAILED: "Failed to Save Service Request",
  SAVE_SURVEY_REQUEST_PROGRESS: "Saving Survey Request",
  SAVE_SURVEY_REQUEST_SUCCESS: "Survey Request Saved",
  SAVE_SURVEY_REQUEST_FAILED: "Failed to Save Survey Request",

  BLOCKED_VESSELS_WARNING_MESSAGE: `Owner/Manager of this vessel has been blocked in
navision with the result that no invoices can be raised till
such time that the outstanding amount either part or full
is collected. Please ensure that the outstanding amount is collected
before completion of this survey, to enable removing the
block in navision and thus enabling raising of invoices.`,
  BLOCK_FEE_WARNING: "Block Fee Time is greater than available visit time. Please reduce the Block Fee Time",
  BEFORE_DUE_DATE_WARNING: "Items credited before 15M will be considered in the previous survey-cycle",
  SAVE_ESP_DATA_PROGRESS: "Saving ESP Report data",
  SAVE_ESP_DATA_SUCCESS: "ESP Report data saved",
  ESP_FORM_COMPLETE: "ESP form completed",
  SAVE_ESP_DATA_FAILED: "Failed to save ESP Report data",
  ESP_FORM_DATA_FAILED_TO_SAVE_COMPLETE: "ESP formdata failed to save complete",
  ESP_FORM_DATA_SAVE: "ESP formdata data saved",
  ESP_FORM_DATA_FAILED_TO_COMPLETE: "ESP form data failed to complete",
  SAVE_TANK_HOLD_EXAMINATION_DATA_PROGRESS: "Saving tank/hold examination Report data",
  TANK_HOLD_EXAMINATION_FORM_COMPLETE: "Tank/Hold Examination form completed",
  SAVE_TANK_HOLD_EXAMINATION_DATA_SUCCESS: "Tank/Hold Examination data saved",
  SAVE_TANK_HOLD_EXAMINATION_SUCCESS: "Tank/Hold Examination Report data saved",
  TANK_HOLD_EXAMINATION_FORM_DATA_FAILED_TO_SAVE_COMPLETE: "Tank/Hold Examination formdata failed to save complete",
  SAVE_TANK_HOLD_EXAMINATION_DATA_FAILED: "Failed to save tank/hold examination Report data",
  SAVE_HULL_SURVEY_REPORT_DATA_PROGRESS: "Saving Hull Survey report Report data",
  HULL_SURVEY_REPORT_FORM_COMPLETE: "Hull Survey Report form completed",
  HULL_SURVEY_REPORT_DATA_SUCCESS: "Hull Survey Report data saved",
  SAVE_HULL_SURVEY_REPORT_SUCCESS: "Hull Survey Report Report data saved",
  HULL_SURVEY_REPORT_FORM_DATA_FAILED_TO_SAVE_COMPLETE: "Hull Survey Report formdata failed to save complete",
  HULL_SURVEY_REPORT_EXAMINATION_DATA_FAILED: "Failed to save Hull Survey Report report data",
  SUSPENSION_REOMMENDATION_PROGRESS: "Sending Suspension Recommendation",
  SUSPENSION_REOMMENDATION_SUCCESS: "Sent Suspension Recommendation",
  SUSPENSION_REOMMENDATION_FAILED: "Failed to send Suspension Recommendation",

  PLAN_SUFFICIENCY_DECLARE_PROGRESS: "Declaring plan sufficiency",
  PLAN_SUFFICIENCY_DECLARE_SUCCESS: "Plan Sufficiency Declare",
  PLAN_SUFFICIENCY_DECLARE_FAILED: "Failed to declare plan sufficiency",

  PASS_TO_HO_FOR_FT_CERTIFICATE_PREPARATION_PROGRESS: "Passing to HO for FT Certificate Preparation",
  PASS_TO_HO_FOR_FT_CERTIFICATE_PREPARATION_SUCCESS: "Passed to HO for FT Certificate Preparation",
  PASS_TO_HO_FOR_FT_CERTIFICATE_PREPARATION_FAILED: "Failed to pass to HO for FT Certificate Preparation",

  CONFIRM_PASS_TO_HO: "Do you want to Pass to HO this report?",
  PASS_TO_HO_FOR_REVIEW_PROGRESS: "Passing to HO for Review",
  PASS_TO_HO_FOR_REVIEW_SUCCESS: "Passed to HO for Review",
  PASS_TO_HO_FOR_REVIEW_FAILED: "Failed to pass to HO for Review",
  PASS_TO_HO_AND_PO_PROGRESS: "Passing to HO for Review and PO for Feedback",
  AUTHORIZE_AND_PO_SUCESS: "Report Authorize and Send to PO for Feedback",
  AUTHORIZE_AND_PO_FAILED: "Failed Report Authorize and Send to PO for Feedback",
  COMPLETE_AND_PO_SUCESS: "Audit Completed and Sent to PO for Feedback",

  PREPARE_FT_CERTIFICATE_PROGRESS: "Preparing FT Certificate",
  PREPARE_FT_CERTIFICATE_SUCCESS: "FT Certificate Prepared",
  PREPARE_FT_CERTIFICATE_FAILED: "Failed to prepare FT Certificate",

  NO_FT_CERTIFICATE_REQUIRED_PROGRESS: "Bypassing Full Term Certificate Preparation",
  NO_FT_CERTIFICATE_REQUIRED_SUCCESS: "Successfully Bypassed Full Term Certificate Preparation",
  NO_FT_CERTIFICATE_REQUIRED_FAILED: "Failed to Bypass Full Term Certificate Preparation",

  ACCEPTING_REVERT_SURVEY_REQUEST_PROGRESS: "Accepting Revert Survey Request",
  ACCEPTING_REVERT_SURVEY_REQUEST_SUCCESS: "Revert Survey Request Accepted",
  ACCEPTING_REVERT_SURVEY_REQUEST_FAILED: "Failed to accept Revert Survey Request",
  REJECTING_REVERT_SURVEY_REQUEST_PROGRESS: "Rejecting Revert Survey Request",
  REJECTING_REVERT_SURVEY_REQUEST_SUCCESS: "Revert Survey Request Rejected",
  REJECTING_REVERT_SURVEY_REQUEST_FAILED: "Failed to reject Revert Survey Request",
  PREPARE_AGREEMENT: "Please Prepare Agreement",
  COMPLETE_MODELS: "Please upload models and complete the checklist",
  SENT_FOR_REVIEW: "Service Report is Sent for Review",

  GELAIDUP_CAN_NOT_COMBINED: "Additional survey categories cannot be combined with GELAIDUP survey.",
  GELAIDUP_WARNING: "Additional survey categories are unavailable since GELAIDUP survey cannot be combined with them.",

  SRFA_ACCEPTED: "SRFA Accepted",
  SRFA_SAVED: "SRFA Saved",
  SAVING_SRFA_PROGRESS: "Saving SRFA",
  SAVING_SRFA_FAILED: "Failed to Save SRFA",

  REJECT_SRFA_MESSAGE: "SRFA will be Rejected",
  REJECT_SRFA_PROGRESS: "Rejecting SRFA",
  REJECT_SRFA_FAILED: "Failed to Reject SRFA",
  REJECT_SRFA_SUCCESS: "SRFA Rejected",

  ONHOLD_SRFA_MESSAGE: "SRFA will be on Hold",
  ONHOLD_SRFA_PROGRESS: "Placing SRFA on Hold",
  ONHOLD_SRFA_FAILED: "Failed to place SRFA on Hold",
  ONHOLD_SRFA_SUCCESS: "SRFA On Hold",

  SRFA_WILL_BE_CANCELLED: "SRFA will be Cancelled",
  CANCELLED_SRFA_PROGRESS: "Cancelling SRFA",
  CANCELLED_SRFA_SUCCESS: "SRFA Cancelled",
  CANCELLED_SRFA_FAILED: "Cancelling SRFA Failed",

  SEND_AGREEMENT_PROGRESS: "Sending Agreement Letter",
  SEND_AGREEMENT_FAILED: "Sending agreement letter failed",
  SEND_AGREEMENT_SUCCESS: "Agreement letter sent",

  REVIEW_COMPLETE_PROGRESS: "Completing Review",
  REVIEW_COMPLETE_SUCCESS: "Review Completed",
  REVIEW_COMPLETE_FAILED: "Review Completion Failed",

  ESP_FORM_SAVE_PROGRESS: "Saving ESP Form",
  ESP_FORM_SAVE_SUCCESS: "ESP Form Saved",
  ESP_FORM_SAVE_FAILED: "Failed to Save ESP Form",

  ESP_FORM_SUBMIT_PROGRESS: "Submitting ESP Form",
  ESP_FORM_SUBMIT_SUCCESS: "ESP Form Submitted",
  ESP_FORM_SUBMIT_FAILED: "Failed to Submit ESP Form",

  ESP_FORM_AMEND_PROGRESS: "Amending ESP Form",
  ESP_FORM_AMEND_SUCCESS: "ESP Form Amended",
  ESP_FORM_AMEND_FAILED: "Failed to Amend ESP Form",

  ESP_FORM_ACCEPT_PROGRESS: "Accepting ESP Form",
  ESP_FORM_ACCEPT_SUCCESS: "ESP Form Accepted",
  ESP_FORM_ACCEPT_FAILED: "Failed to Accept ESP Form",

  TAWA_ASSIGN_MENTOR: "Please Select Mentor",
  TAWA_SELECT_EMPLOYEE: "Please select an employee",

  SAVE_BLOCK_PANEL_PROGRESS: "Saving Block and Panel",
  SAVE_BLOCK_PANEL_DETAILS: "Block and Panel Details Saved",
  SAVE_BLOCK_PANEL_DETAILS_FAILED: "Failed to save Block and Panel Details",

  PLEASE_SELECT_YARD_NO_MODE_OF_CONSTRUCTION: "Please Select Yard No. and Mode of Construction",

  SAVE_TANK_SPACES_PROGRESS: "Saving Tank and Spaces",
  SAVE_TANK_SPACES_DETAILS: "Tank and Spaces Details Saved",
  SAVE_TANK_SPACES_DETAILS_FAILED: "Failed to save Tank and Spaces Details",

  PS_FORM_DELETE_SUCCESS: "Form Deleted Successfully",
  PS_UNDO_PROGRESS: "Undoing Deleted Form",
  PS_UNDO_SUCCESS: "Undone Deleted Form",
  PS_UNDO_ERROR: "Failed to Undo",

  PS_FILE_SIZE_WARNING: "Kindly zip your files before uploading. Individual file sizes should not exceed 80 MB.",

  DELETE_CERTIFICATE_REQUIRED_MESSAGE: "Please delete the prepared Digital Certificate in order to change the Visit Dates",

  SHIP_DETENTION_DETAILS_SUCCESS: "Ship detention details saved successfully",
  SHIP_DETENTION_DETAILS_PROGRESS: "Ship detention details in progress",
  SHIP_DETENTION_DETAILS_FAILED: "Ship detention details save failed",

  ADD_REMARKS_PROGRESS: "Remarks are being added.",
  ADD_REMARKS_SUCCESS: "Remarks were added successfully",
  ADD_REMARKS_FAILED: "Failed to add remarks.",

  ISM_VISIT_BREAK_MESSAGE: 'NOTE: To exclude the duration minutes (e.g., lunch, dinner, etc.) from the schedule report, please select the "Break" option.',
  ISM_MANUAL_SCHEDULE_MESSAGE:
    "NOTE: If manual entry is selected, please note that the changes cannot be reverted. Ensure all details are accurate before proceeding.",
  FORM_COMPLETE_SUCCESS: "Form completed",
  FORM_COMPLETE_PROGRESS: "Form completion in progress",
  FORM_COMPLETE_ERROR: "Failed to complete form",

  FILE_SIZE_WARNING: "Kindly zip your files before uploading. Individual file sizes should not exceed 12 MB.",

  SUPPLIER_ACCEPTING_CPA_PROGRESS: "Accepting Corrective/Preventive action",
  SUPPLIER_CPA_SUCCESS: "Corrective/Preventive Action Accepted",
  SUPPLIER_CPA_FAILED: "Failed to complete Corrective/Preventive action",

  RETURN_CPA_PROGRESS: "Returning Corrective/Preventive action",
  RETURN_CPA_SUCCESS: "Corrective/Preventive Action Returned",
  RETURN_CPA_FAILED: "Failed to return Corrective/Preventive action",

  ACCEPTING_CPA_PROGRESS: "Completing Corrective/Preventive action",
  ACCEPTING_CPA_SUCCESS: "Corrective/Preventive Action Completed",
  ACCEPTING_CPA_FAILED: "Failed to accept Corrective/Preventive action",

  CAPA_FEEDBACK_PROGRESS: "Saving form",
  CAPA_FEEDBACK_SUCCESS: "Form saved",
  CAPA_FEEDBACK_FAILED: "Failed to save form",

  SUBMIT_FEEDBACK_PROGRESS: "Submitting feedback",
  SUBMIT_FEEDBACK_SUCCESS: "Feedback submitted",
  SUBMIT_FEEDBACK_FAILED: "Failed to submit feedback",
  SUBMIT_FEEDACK_SUCCESS: "CPA Action Submitted",
  SUBMIT_FEEDACK_FAILED: "failed to submit CPA action",
  SSA_FILE_SIZE_WARNING: "Kindly zip your files before uploading. Individual file sizes should not exceed 80 MB.",
  SRFA_FILE_SIZE_WARNING: "Kindly zip your files before uploading. Individual file sizes should not exceed 50 MB.",

  DESPATCH_NUMBER_GENERATED: "Dispatch Number has been generated",
  DESPATCH_NUMBER_PROGRESS: "Generating Dispatch Number",
  RETURN_FOR_AMENDMENT_RQUIRED: "Please add a remark before returning for amendment.",
  RETURN_FOR_AMENDMENT_MESSAGE: "No Review Remarks found.",

  DECLARE_CLEARANCE_PROGRESS: "Declaring Clearance",
  DECLARE_CLEARANCE_SUCCESS: "Declare Clearance",
  DECLARE_CLEARANCE_FAILED: "Failed to Declare Clearance",
  DECLARE_CLEARANCE_WARNING: "The Conditions For Clearance are Not Satisfied. Please add Exclusions if required.",

  PAC_CLEARANCE_COMPLETED: "PAC Clearance Completed",
  STS_CLEARANCE_COMPLETED: "STS Clearance Completed",

  DELETE_IN_PROGRESS: "Delete in progress",
  DELETE_SUCCESSFUL: "Deleted successfully",
  DELETE_FAILED: "Deleted failed",

  ONE_BREAK_REQUIRED_WARNING: "Atleast one Break is required",
  TWO_BREAKS_REQUIRED_WARNING: "Atleast two Breaks are required",

  NAVY_SURVEY_REQUEST_WILL_BE_CANCELLED: "Survey Request will be cancelled",
  REQUEST_WILL_BE_SUBMIT_ALERT: "Request will be submitted",
  CANCELLED_NAVY_SURVEY_REQUEST_PROGRESS: "Cancelling Survey Request",
  CANCELLED_NAVY_SURVEY_REQUEST_SUCCESS: "Survey Request cancelled",
  CANCELLED_NAVY_SURVEY_REQUEST_FAILED: "Cancelling Survey Request failed",
  CANT_PLAN_VISIT_DATE_MORE_THAN_3_DAYS_FROM_CURRENT_DATE: " Can't plan visit date more than 3 days from current date",
  INVALID_VISIT_DATE: "Invalid Visit Date",
  NAVY_AMEND_CERTIFICATE_CONFIRMATION: "Do you want to Amend Certificate",
  NAVY_FETCH_DATA_SURE: "Are you sure you want to fetch previous data?",
  NAVY_FETCH_DATA_COMPLETED: "Previous data fetched successfully",
  NAVY_FETCH_DATA_INPROGRESS: "Fetching previous data",
  NAVY_FETCH_DATA_FAILED: "Failed to fetch previous data",

  SHIP_VETTING_SURVEY_REQUEST_WILL_BE_CANCELLED: "Survey Request will be cancelled",
  CANCELLED_SHIP_VETTING_SURVEY_REQUEST_PROGRESS: "Cancelling Survey Request",
  CANCELLED_SHIP_VETTING_SURVEY_REQUEST_SUCCESS: "Survey Request cancelled",
  CANCELLED_SHIP_VETTING_SURVEY_REQUEST_FAILED: "Cancelling Survey Request failed",

  MXR_SURVEY_REQUEST_WILL_BE_CANCELLED: "Survey Request will be cancelled",
  MXR_SURVEY_REQUEST_WILL_BE_UPDATED: "Survey Request will be updated",
  CANCELLED_MXR_SURVEY_REQUEST_PROGRESS: "Cancelling Survey Request",
  CANCELLED_MXR_SURVEY_REQUEST_SUCCESS: "Survey Request cancelled",
  CANCELLED_MXR_SURVEY_REQUEST_FAILED: "Cancelling Survey Request failed",

  NAVY_SURVEY_REQUEST_SAVED: "Request has been submitted",
  NAVY_SURVEY_REQUEST_FAILED: "Survey Request Failed",
  SAVING_NAVY_SURVEY_REQUEST_PROGRESS: "Saving Survey Request",

  NAVY_SURVEY_REQUEST_UPDATE_FAILED: "Survey Request Update Failed",
  NAVY_SURVEY_REQUEST_UPDATED: "Survey Request Updated",
  UPDATE_NAVY_SURVEY_REQUEST_PROGRESS: "Updating Navy Survey Request",
  UNFILLED_FORM_ERROR: "An unfilled form cannot be save",

  SHIP_VETTING_REQUEST_WILL_BE_SUBMIT_ALERT: "Survey request will be updated",
  UPDATE_SHIP_VETTING_SURVEY_REQUEST_PROGRESS: "Updating survey request",

  MXR_SURVEY_REQUEST_SAVED: "Request has been submitted",
  MXR_SURVEY_REQUEST_FAILED: "Survey Request Failed",
  SAVING_MXR_SURVEY_REQUEST_PROGRESS: "Saving Survey Request",

  MXR_SURVEY_REQUEST_UPDATE_FAILED: "Survey Request Update Failed",
  MXR_SURVEY_REQUEST_UPDATED: "Survey Request Updated",
  UPDATE_MXR_SURVEY_REQUEST_PROGRESS: "Updating Survey Request",

  CHANGE_SURVEY_REQUEST_WARNING: "Changing Request Type will discard your existing Form data",
  SEND_FOR_REVIEW_CONFIRMATION_NAVY: "Your reports are being submitted for review and you will be not able to make additional modifications.",
  RETURN_FOR_AMENDMENT_CONFIRMATION: "The report will be returned for amendment.",
  SURVEY_AUTHORIZED: "Survey has been authorised",
  MINIMUM_ONE_SURVEYOR_REQUIRED: "Minimum one Surveyor should be required",

  MOD_CON_CONFIRMATORY_REMARKS_INPROGRESS: "Saving Modification convesation confirmatory remarks",
  MOD_CON_CONFIRMATORY_REMARKS_SUCCESS: "Modification convesation confirmatory remarks saved",
  MOD_CON_CONFIRMATORY_REMARKS_FAILED: "Failed to save Modification convesation confirmatory remarks",

  INWATER_SURVEY_SAVED: "In-water Survey Saved",
  FAILED_SAVE_TO_INWATER_SURVEY: "Failed to save In-water Survey",
  SAVING_INWATER_SURVEY: "Saving In-water Surveys",

  INWATER_SURVEY_UPDATED: "In-water Survey Updated",
  FAILED_TO_UPDATE_INWATER_SURVEY: "Failed to update In-water Survey",
  UPDATING_INWATER_SURVEY: "Updating In-water Surveys",

  SAVE_AUTH_LETTER_TEMPLATE_PROGRESS: "Save Auth Letter Template In Progress",
  SAVE_AUTH_LETTER_TEMPLATE_SUCCESS: "Save Auth Letter Template Success",
  SAVE_AUTH_LETTER_TEMPLATE_FAILED: "Save Auth Letter Template Failed",

  ADD_MOU_SUCCESS: "MOU added successfully",
  ADD_MOU_PROGRESS: "Adding MOU",
  ADD_MOU_FAILED: "Failed to add MOU",
  UPDATE_MOU_SUCCESS: "MOU updated successfully",
  UPDATE_MOU_PROGRESS: "Updating MOU",
  UPDATE_MOU_FAILED: "Failed to update MOU",
  ARE_YOU_SURE_REMOVE_MOU_COLOR: "Are you sure you want to remove this MOU?",
  REMOVE_MOU_COLOR_SUCCESS: "MOU removed successfully",
  REMOVE_MOU_COLOR_PROGRESS: "Removing MOU",
  REMOVE_MOU_COLOR_FAILED: "Failed to remove MOU",

  ADDING_REMARK_PROGRESS: "Adding Remark",
  ADDING_REMARK_SUCCESS: "Remark added",
  ADDING_REMARK_FAILED: "Failed to add Remark",

  SEND_FOR_REVIEW_CONFIRMATION_MC: "Supporting documents are not uploaded as per IOM. Please upload supporting documents for proceeding further.",
  MC_SEND_FOR_REVIEW_CONFIRMATION_MC: "Please upload supporting documents for proceeding further.",
  DELETE_SURVEY_REQUEST_WARNING: "Once deleted, the record cannot be recovered",
  DELETED_SURVEY_REQUEST: "Survey Request Deleted",
  DELETING_SURVEY_REQUEST: "Deleting Survey Request",
  FAILED_TO_DELETE_SURVEY_REQUEST: "Failed to delete Survey Request",
  REQUESTED_DATE_SHOULD_NOT_BE_GREATER_THAN_PROPOSED_DATE: "Requested date should not be greater than proposed date",
  REMARKS_REQUIRED: "Remarks are required for Short term certificate",

  SAVE_REQUEST_FAILED: "Save Request Failed",
  UPDATE_REQUEST_FAILED: "Update Request Failed",
  DAMANGE_ANALYSIS_SAVING_PROGRESS: "Saving Damage Analysis Record",
  DAMANGE_ANALYSIS_SAVED: "Damage Analysis Record Saved",
  DAMANGE_ANALYSIS_UPDATED: "Analysis Record Updated",
  DAMANGE_ANALYSIS_UPDATED_PROGRESS: "Updating Analysis Record",

  SHIP_CLASS_TRANSFER_SAVED: "Ship Class Transfer Saved",
  FAILED_SAVE_TO_SHIP_CLASS_TRANSFER: "Failed to save Ship Class Transfer",
  SAVING_SHIP_CLASS_TRANSFER: "Saving Ship Class Transfers",

  SHIP_CLASS_TRANSFER_UPDATED: "Ship Class Transfer Updated",
  FAILED_TO_UPDATE_SHIP_CLASS_TRANSFER: "Failed to update Ship Class Transfer",
  UPDATING_SHIP_CLASS_TRANSFER: "Updating Ship Class Transfers",

  NOTATION_SAVED: "Notation Saved",
  FAILED_SAVE_TO_NOTATION: "Failed to save Notation",
  SAVING_NOTATION: "Saving Notation",

  NOTATION_UPDATED: "Notation Updated",
  FAILED_TO_UPDATE_NOTATION: "Failed to update Notation",
  UPDATING_NOTATION: "Updating Notation",

  CERTIFICATE_REVIEW_CONFIRMATION: "Do you want to review this certificates?",

  CERTIFICATE_SEND_SUCCESS: "Certificate sent for review",
  CERTIFICATE_SEND_FAILED: "Failed to set certificate for review",

  SURVEY_REQUEST_UPDATED: "Survey Request Updated",
  SURVEY_REQUEST_FAILED: "Survey Request Failed",
  SURVEY_REQUEST_PROGRESS: "Saving Survey Request",
  SURVEY_REQUEST_UPDATE_FAILED: "Failed To Update Survey Request",
  ASSIGNED_REVIEWER_SUCCESS: "Reviewer assigned",
  ASSIGNED_REVIEWER_PROGRESS: "Assigning Reviewer",
  ASSIGN_REVIEWER_FAILED: "Failed to assign Reviewer",

  REINCLASS_SUSPENDED_SHIP: "The scope of the reinstatement class, statutory survey and audits is to be confirmed prior undertaking Class reinstatement.",
  VESSEL_UNDER_CM_PR17:
    'Vessel is identified under "CM". In case "CM" is recommended to be continued on completion (after 3 months); then IACS PR17 need to be raised prior survey completion.',
  IS_SURVEY_UNDER_FORCE_MAJEURE: "Survey undertaken due to Force Majeure",
  LAST_MARK_DATE_REINCLASS_SUSPENDED_SHIP:
    'The Last Survey Date cannot be marked as the scope of the Reinstatement Class Survey has not yet been updated.\n The respective RM/AM/SIC can update it in the form:"Miscellaneous => Update Scope of Class Reinstatement Surveys."',

  LAST_MARK_DATE_FORCE_MAJEURE_WARNING: "Please mark whether survey undertaken due to Force Majeure before marking last visit",

  APPLYING_CONFIG: "Applying config",
  FAILED_APPLYING_CONFIG: "Failed to Apply config",
  FUTURE_LAST_SURVEY_DATE_VALIDATION: "Cannot send the certificate since last survey date is in future",
  DELETE_CERT_VALIDATION: "Deletion is not allowed while the certificate is under review",
  AUDIT_PLAN_SAVED_PROGRESS: "Saving Audit Plan",
  AUDIT_PLAN_SAVED: "Audit Plan Saved",
  AUDIT_PLAN_UPDATED: "Audit Plan Updated",
  AUDIT_PLAN_SUBMITTED_PROGRESS: "Submitting Audit Plan",
  AUDIT_PLAN_UPDATE_PROGRESS: "Updating Audit Plan",
  AUDIT_PLAN_SUBMITTED: "Audit Plan Submitted",
  AUDIT_PLAN_REQUEST_UPDATE_FAILED: "Audit Plan Update Failed",
  AUDIT_PLAN_FAILED: "Audit Plan Failed",
  SENDING_SCHEDULE_DETAILS: "Sending schedule details",
  SCHEDULE_SENT_SUCEESFULLY: "Schedule sent successfully",
  SCHEDULE_SENT_FAIL: "Schedule sent fail",
  SCHEDULE_SAVED_SUCESSFULLY: "Schedule saved successfully",
  SCHEDULE_SAVE_Failed: "Schedule saved failed",

  BLOCK_FEE_DETAILS_SAVE_PROGRESS: "Block Fee Details Save in progress",
  BLOCK_FEE_DETAILS_SAVE_SUCCESS: "Block Fee Details Saved",
  BLOCK_FEE_DETAILS_SAVE_FAILED: "Failed to save Block Fee Details",

  REQUEST_SUBMITTED_FOR_EXTENSION: "Request Submitted for Extension",
  FAILED_TO_SUBMIT: "Failed to Submit",
  REQUEST_EXTENDED: "Approve Request",
  FAILED_TO_EXTEND: "Failed to Extend",

  REQUEST_PASS_TO_PO: "Request Pass to PO(Process Owner)",
  FAILED_TO_PASS: "Failed to Pass",

  DO_YOU_WANT_TO_UNDO: "This action will remove the ESP item from the report.",
  ML_ITEM_UNDONE_SUCCESSFULLY: "ESP Item removed successfully.",
  FAILED_TO_UNDO: "Failed to remove.",
  IN_PROGRESS: "In progress",
  PLEASE_SAVE_CHANGES: "Please save your changes",
  AUDIT_AUTHORIZE_SUCCESS: "Audit has been completed",
  REASON_FOR_DELAY: "Reason for Delay",
  REASON_FOR_DELAY_UPDATED: "Reason for Delay Updated",
  REASON_FOR_DELAY_FAILED: "Failed to Updated",
  REASON_FOR_DELAY_PROCESS: "Updating Reason for Delay in Process",

  AUDITOR_ADDED_SUCESSFULLY: "Auditor saved successfully",
  AUDITOR_UPDATED_SUCESSFULLY: "Auditor updated successfully",
  AUDITOR_ADD_FAILED: "Failed to saved auditor",
  AUDITOR_UPDATE_FAILED: "Failed to update auditor",
  AUDITOR_ADDED_INPROGRESS: "Saving auditor",
  AUDITOR_UPDATE_INPROGRESS: "Updating auditor",

  DELETE_FILE_PROGRESS: "Deleting file",
  DELETE_FILE_SUCCESS: "File deleted",
  DELETE_FILE_FAILED: "Failed to delete file",
};

export default MESSAGES;
